import { CommonModule } from '@angular/common';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SearchCountryField, CountryISO, PhoneNumberFormat, NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { AuthService } from '../../Service/app-service';
import { SearchPipe } from '../../search-pipe.pipe';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { DomSanitizer } from '@angular/platform-browser';
import { Component, Input, ViewChild } from '@angular/core';
import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { NgSelectModule } from '@ng-select/ng-select';
import { forkJoin } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HomeComponent } from '../home/home.component';

@Component({
  selector: 'app-namertune',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModule,
    NgSelectModule,
    NgxIntlTelInputModule,
    NgxSpinnerModule,
    NgMultiSelectDropDownModule,
    AngularMultiSelectModule,
    HomeComponent  //changes by Naved
  ],
  templateUrl: './namertune.component.html',
  styleUrl: './namertune.component.css'
})
export class NamertuneComponent {
  emailRegex: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(com|org|net|edu|gov|in|jp|[a-zA-Z]{2,})$/;
  selectedImage: string | ArrayBuffer | null = null;
  selectedenereImage: string | ArrayBuffer | null = null;
  showCurrentPassword = false;
  showNewPassword = false;
  errorMessageForPublisher = '';
  showConfirmPassword = false;
  selectedCountries = 'Eligible';
  showFilteredOptions: boolean = false;
  selectAll: boolean = false;
  selectedTab: string = 'All';
  musicFileUrl: string | null = null;
  crbtFileUrl: string | null = null;
  ivrFileUrl: string | null = null;
  isPasswordVisible: boolean = false;
  dropdownSettings = {};
  @Input() minLength: number = 20; // Default minimum length
  @Input() maxLength: number = 200; // Default maximum length
  tagsSettings = {};
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  tagsArray: any[] = [];
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  toBeDeletedId: any;
  toBeDeletedText: any;
  toBeEditedTagId: any;
  deploymentsArray: any[] = [];
  genreArray: any[] = [];
  artistArray: any[] = [];
  role: boolean = false;
  user: boolean = false;
  userArray: any[] = [];
  roleArray: any[] = [];
  publisherArray: any[] = [];
  paginatedData: any[] = [];
  languageArray: any[] = [];
  musicArray: any[] = [];
  countryArray: any[] = [];
  countrySettings = {};
  selectedCountryoption: string = 'Eligible';
  previewImageUrl: string | null = null;
  preViewImage: File | null = null;
  filteredMusicArray: any[] = [];
  filteredTgasArray: any[] = [];
  filteredPublisherArray: any[] = [];
  filteredDeployementArray: any[] = [];
  filteredArtistArray: any[] = [];
  filteredGeneresArray: any[] = [];
  genreListedArray: any[] = [];
  tagListedArray: any[] = [];
  userListedArray: any[] = [];
  roleListedArray: any[] = [];
  artistListedArray: any[] = [];
  publisherListedArray: any[] = [];
  deploymentListedArray: any[] = [];
  // deploymentListedArray:any [] = [];
  // deploymentListedArray:any [] = [];
  // deploymentListedArray:any [] = [];
  filteredUserArray: any[] = [];
  filteredRoleArray: any[] = []; selectedCrbtFile: File | null = null; statusChangeText: any;
  statusChangeMuiscDetails: any;
  selectedTax: any;
  userName: any;
  roles: any;
  tabMusicArray: any[] = [];
  publisherStatus: any;
  activePublishers: any[] = [];
  selectedIvrFile: File | null = null;;
  selectedMuiscFile: File | null = null;;
  changePreferredCountries() { this.preferredCountries = [CountryISO.India, CountryISO.Canada]; }
  isOn: boolean = false;
  music: boolean = false;
  musicListedArray: any = [];
  openConfirmChnagePopup: boolean = false;
  conentApproval: boolean = false;
  countries: { code: string, name: string }[] = [
    { code: 'AF', name: 'Afghanistan' },
    { code: 'AL', name: 'Albania' },
    { code: 'DZ', name: 'Algeria' },
    { code: 'AS', name: 'American Samoa' },
    { code: 'AD', name: 'Andorra' },
    { code: 'AO', name: 'Angola' },
    { code: 'AI', name: 'Anguilla' },
    { code: 'AQ', name: 'Antarctica' },
    { code: 'AG', name: 'Antigua and Barbuda' },
    { code: 'AR', name: 'Argentina' },
    { code: 'AM', name: 'Armenia' },
    { code: 'AW', name: 'Aruba' },
    { code: 'AU', name: 'Australia' },
    { code: 'AT', name: 'Austria' },
    { code: 'AZ', name: 'Azerbaijan' },
    { code: 'BS', name: 'Bahamas' },
    { code: 'BH', name: 'Bahrain' },
    { code: 'BD', name: 'Bangladesh' },
    { code: 'BB', name: 'Barbados' },
    { code: 'BY', name: 'Belarus' },
    { code: 'BE', name: 'Belgium' },
    { code: 'BZ', name: 'Belize' },
    { code: 'BJ', name: 'Benin' },
    { code: 'BM', name: 'Bermuda' },
    { code: 'BT', name: 'Bhutan' },
    { code: 'BO', name: 'Bolivia' },
    { code: 'BQ', name: 'Bonaire, Sint Eustatius and Saba' },
    { code: 'BA', name: 'Bosnia and Herzegovina' },
    { code: 'BW', name: 'Botswana' },
    { code: 'BV', name: 'Bouvet Island' },
    { code: 'BR', name: 'Brazil' },
    { code: 'IO', name: 'British Indian Ocean Territory' },
    { code: 'BN', name: 'Brunei Darussalam' },
    { code: 'BG', name: 'Bulgaria' },
    { code: 'BF', name: 'Burkina Faso' },
    { code: 'BI', name: 'Burundi' },
    { code: 'CV', name: 'Cabo Verde' },
    { code: 'KH', name: 'Cambodia' },
    { code: 'CM', name: 'Cameroon' },
    { code: 'CA', name: 'Canada' },
    { code: 'KY', name: 'Cayman Islands' },
    { code: 'CF', name: 'Central African Republic' },
    { code: 'TD', name: 'Chad' },
    { code: 'CL', name: 'Chile' },
    { code: 'CN', name: 'China' },
    { code: 'CX', name: 'Christmas Island' },
    { code: 'CC', name: 'Cocos (Keeling) Islands' },
    { code: 'CO', name: 'Colombia' },
    { code: 'KM', name: 'Comoros' },
    { code: 'CG', name: 'Congo' },
    { code: 'CD', name: 'Congo, Democratic Republic of the' },
    { code: 'CK', name: 'Cook Islands' },
    { code: 'CR', name: 'Costa Rica' },
    { code: 'HR', name: 'Croatia' },
    { code: 'CU', name: 'Cuba' },
    { code: 'CW', name: 'Curaçao' },
    { code: 'CY', name: 'Cyprus' },
    { code: 'CZ', name: 'Czech Republic' },
    { code: 'DK', name: 'Denmark' },
    { code: 'DJ', name: 'Djibouti' },
    { code: 'DM', name: 'Dominica' },
    { code: 'DO', name: 'Dominican Republic' },
    { code: 'EC', name: 'Ecuador' },
    { code: 'EG', name: 'Egypt' },
    { code: 'SV', name: 'El Salvador' },
    { code: 'GQ', name: 'Equatorial Guinea' },
    { code: 'ER', name: 'Eritrea' },
    { code: 'EE', name: 'Estonia' },
    { code: 'SZ', name: 'Eswatini' },
    { code: 'ET', name: 'Ethiopia' },
    { code: 'FK', name: 'Falkland Islands (Malvinas)' },
    { code: 'FO', name: 'Faroe Islands' },
    { code: 'FJ', name: 'Fiji' },
    { code: 'FI', name: 'Finland' },
    { code: 'FR', name: 'France' },
    { code: 'GF', name: 'French Guiana' },
    { code: 'PF', name: 'French Polynesia' },
    { code: 'TF', name: 'French Southern Territories' },
    { code: 'GA', name: 'Gabon' },
    { code: 'GM', name: 'Gambia' },
    { code: 'GE', name: 'Georgia' },
    { code: 'DE', name: 'Germany' },
    { code: 'GH', name: 'Ghana' },
    { code: 'GI', name: 'Gibraltar' },
    { code: 'GR', name: 'Greece' },
    { code: 'GL', name: 'Greenland' },
    { code: 'GD', name: 'Grenada' },
    { code: 'GP', name: 'Guadeloupe' },
    { code: 'GU', name: 'Guam' },
    { code: 'GT', name: 'Guatemala' },
    { code: 'GG', name: 'Guernsey' },
    { code: 'GN', name: 'Guinea' },
    { code: 'GW', name: 'Guinea-Bissau' },
    { code: 'GY', name: 'Guyana' },
    { code: 'HT', name: 'Haiti' },
    { code: 'HM', name: 'Heard Island and McDonald Islands' },
    { code: 'VA', name: 'Holy See' },
    { code: 'HN', name: 'Honduras' },
    { code: 'HK', name: 'Hong Kong' },
    { code: 'HU', name: 'Hungary' },
    { code: 'IS', name: 'Iceland' },
    { code: 'IN', name: 'India' },
    { code: 'ID', name: 'Indonesia' },
    { code: 'IR', name: 'Iran' },
    { code: 'IQ', name: 'Iraq' },
    { code: 'IE', name: 'Ireland' },
    { code: 'IM', name: 'Isle of Man' },
    { code: 'IL', name: 'Israel' },
    { code: 'IT', name: 'Italy' },
    { code: 'JM', name: 'Jamaica' },
    { code: 'JP', name: 'Japan' },
    { code: 'JE', name: 'Jersey' },
    { code: 'JO', name: 'Jordan' },
    { code: 'KZ', name: 'Kazakhstan' },
    { code: 'KE', name: 'Kenya' },
    { code: 'KI', name: 'Kiribati' },
    { code: 'KP', name: 'Korea, Democratic People\'s Republic of' },
    { code: 'KR', name: 'Korea, Republic of' },
    { code: 'KW', name: 'Kuwait' },
    { code: 'KG', name: 'Kyrgyzstan' },
    { code: 'LA', name: 'Lao People\'s Democratic Republic' },
    { code: 'LV', name: 'Latvia' },
    { code: 'LB', name: 'Lebanon' },
    { code: 'LS', name: 'Lesotho' },
    { code: 'LR', name: 'Liberia' },
    { code: 'LY', name: 'Libya' },
    { code: 'LI', name: 'Liechtenstein' },
    { code: 'LT', name: 'Lithuania' },
    { code: 'LU', name: 'Luxembourg' },
    { code: 'MO', name: 'Macao' },
    { code: 'MG', name: 'Madagascar' },
    { code: 'MW', name: 'Malawi' },
    { code: 'MY', name: 'Malaysia' },
    { code: 'MV', name: 'Maldives' },
    { code: 'ML', name: 'Mali' },
    { code: 'MT', name: 'Malta' },
    { code: 'MH', name: 'Marshall Islands' },
    { code: 'MQ', name: 'Martinique' },
    { code: 'MR', name: 'Mauritania' },
    { code: 'MU', name: 'Mauritius' },
    { code: 'YT', name: 'Mayotte' },
    { code: 'MX', name: 'Mexico' },
    { code: 'FM', name: 'Micronesia (Federated States of)' },
    { code: 'MD', name: 'Moldova (Republic of)' },
    { code: 'MC', name: 'Monaco' },
    { code: 'MN', name: 'Mongolia' },
    { code: 'ME', name: 'Montenegro' },
    { code: 'MS', name: 'Montserrat' },
    { code: 'MA', name: 'Morocco' },
    { code: 'MZ', name: 'Mozambique' },
    { code: 'MM', name: 'Myanmar' },
    { code: 'NA', name: 'Namibia' },
    { code: 'NR', name: 'Nauru' },
    { code: 'NP', name: 'Nepal' },
    { code: 'NL', name: 'Netherlands' },
    { code: 'NC', name: 'New Caledonia' },
    { code: 'NZ', name: 'New Zealand' },
    { code: 'NI', name: 'Nicaragua' },
    { code: 'NE', name: 'Niger' },
    { code: 'NG', name: 'Nigeria' },
    { code: 'NU', name: 'Niue' },
    { code: 'NF', name: 'Norfolk Island' },
    { code: 'MP', name: 'Northern Mariana Islands' },
    { code: 'NO', name: 'Norway' },
    { code: 'OM', name: 'Oman' },
    { code: 'PK', name: 'Pakistan' },
    { code: 'PW', name: 'Palau' },
    { code: 'PS', name: 'Palestine, State of' },
    { code: 'PA', name: 'Panama' },
    { code: 'PG', name: 'Papua New Guinea' },
    { code: 'PY', name: 'Paraguay' },
    { code: 'PE', name: 'Peru' },
    { code: 'PH', name: 'Philippines' },
    { code: 'PN', name: 'Pitcairn' },
    { code: 'PL', name: 'Poland' },
    { code: 'PT', name: 'Portugal' },
    { code: 'PR', name: 'Puerto Rico' },
    { code: 'QA', name: 'Qatar' },
    { code: 'RE', name: 'Réunion' },
    { code: 'RO', name: 'Romania' },
    { code: 'RU', name: 'Russian Federation' },
    { code: 'RW', name: 'Rwanda' },
    { code: 'BL', name: 'Saint Barthélemy' },
    { code: 'KN', name: 'Saint Kitts and Nevis' },
    { code: 'LC', name: 'Saint Lucia' },
    { code: 'MF', name: 'Saint Martin (French part)' },
    { code: 'SX', name: 'Saint Martin (Dutch part)' },
    { code: 'SM', name: 'San Marino' },
    { code: 'ST', name: 'Sao Tome and Principe' },
    { code: 'SA', name: 'Saudi Arabia' },
    { code: 'SN', name: 'Senegal' },
    { code: 'RS', name: 'Serbia' },
    { code: 'SC', name: 'Seychelles' },
    { code: 'SL', name: 'Sierra Leone' },
    { code: 'SG', name: 'Singapore' },
    { code: 'SX', name: 'Sint Maarten (Dutch part)' },
    { code: 'SK', name: 'Slovakia' },
    { code: 'SI', name: 'Slovenia' },
    { code: 'SB', name: 'Solomon Islands' },
    { code: 'SO', name: 'Somalia' },
    { code: 'ZA', name: 'South Africa' },
    { code: 'GS', name: 'South Georgia and the South Sandwich Islands' },
    { code: 'SS', name: 'South Sudan' },
    { code: 'ES', name: 'Spain' },
    { code: 'LK', name: 'Sri Lanka' },
    { code: 'SD', name: 'Sudan' },
    { code: 'SR', name: 'Suriname' },
    { code: 'SJ', name: 'Svalbard and Jan Mayen' },
    { code: 'SZ', name: 'Sweden' },
    { code: 'CH', name: 'Switzerland' },
    { code: 'SY', name: 'Syrian Arab Republic' },
    { code: 'TW', name: 'Taiwan, Province of China' },
    { code: 'TJ', name: 'Tajikistan' },
    { code: 'TZ', name: 'Tanzania, United Republic of' },
    { code: 'TH', name: 'Thailand' },
    { code: 'TL', name: 'Timor-Leste' },
    { code: 'TG', name: 'Togo' },
    { code: 'TK', name: 'Tokelau' },
    { code: 'TO', name: 'Tonga' },
    { code: 'TT', name: 'Trinidad and Tobago' },
    { code: 'TN', name: 'Tunisia' },
    { code: 'TR', name: 'Turkey' },
    { code: 'TM', name: 'Turkmenistan' },
    { code: 'TC', name: 'Turks and Caicos Islands' },
    { code: 'TV', name: 'Tuvalu' },
    { code: 'UG', name: 'Uganda' },
    { code: 'UA', name: 'Ukraine' },
    { code: 'AE', name: 'United Arab Emirates' },
    { code: 'GB', name: 'United Kingdom' },
    { code: 'US', name: 'United States of America' },
    { code: 'UM', name: 'United States Minor Outlying Islands' },
    { code: 'UY', name: 'Uruguay' },
    { code: 'UZ', name: 'Uzbekistan' },
    { code: 'VU', name: 'Vanuatu' },
    { code: 'VE', name: 'Venezuela' },
    { code: 'VN', name: 'Viet Nam' },
    { code: 'WF', name: 'Wallis and Futuna' },
    { code: 'EH', name: 'Western Sahara' },
    { code: 'YE', name: 'Yemen' },
    { code: 'ZM', name: 'Zambia' },
    { code: 'ZW', name: 'Zimbabwe' }
  ];
  publisher: boolean = false;
  filteredCountries = this.countries;
  deployments: boolean = false;
  tags: boolean = false;
  showContentConfiguration: boolean = false;
  publishers = [
    { name: 'Veniso', email: 'aditya@veniso.com' },
    { name: 'Sonic Signal Technology', email: 'tnyemba@sonic.com' },
    { name: 'Jive Zimbabwe', email: 'benjy@jivestore.com' },
    { name: 'Sonic Signal Technology', email: 'tnyemba@sonic.com' },
    { name: 'Jive Zimbabwe', email: 'benjy@jivestore.com' },
    { name: 'Sonic Signal Technology', email: 'tnyemba@sonic.com' },
    { name: 'Jive Zimbabwe', email: 'benjy@jivestore.com' },
    { name: 'Sonic Signal Technology', email: 'tnyemba@sonic.com' },
    { name: 'Jive Zimbabwe', email: 'benjy@jivestore.com' },
    { name: 'Sonic Signal Technology', email: 'tnyemba@sonic.com' },
    { name: 'Jive Zimbabwe', email: 'benjy@jivestore.com' },
    { name: 'Sonic Signal Technology', email: 'tnyemba@sonic.com' },
    { name: 'Jive Zimbabwe', email: 'benjy@jivestore.com' },
    { name: 'Sonic Signal Technology', email: 'tnyemba@sonic.com' },
    { name: 'Jive Zimbabwe', email: 'benjy@jivestore.com' },
    // Add more publisher data as needed
  ];

  searchTerm: string = '';
  filteredPublishers = [...this.publishers];
  pageSize: number = 10;
  currentPage: number = 1
  recordsPerPage: number = 10;
  totalEntries: number = 0;
  totalPages: number = 0;
  pages: (number | string)[] = [];
  displayedRecords: any[] = [];
  paginatedPublishers: any = [];
  openMusicAddForm: boolean = false;
  containers: boolean = false;
  Artist: boolean = false;
  Generes: boolean = false;
  tagForm: any;
  deploymentForm: any;
  artistForm: any;
  genreForm: any;
  userForm: any;
  roleForm: any;
  publisherForm: any;
  musicForm: any;
  filterForm: any;
  passwordForm: any;
  tagsListingForm: any;
  namertune: boolean = false  //changes by Naved
  openNamertuneAddForm: boolean = false; //changes by Naved
  rejectedNametuneId: any; //changes by Naved
  requestName: any; //changes by Naved
  publisherName: any //changes by Naved
  approvalPending: boolean = false
  approved: boolean = false;


  constructor(private el: ElementRef, private renderer: Renderer2, private modalService: NgbModal, private tosterService: ToastrService, private sanitizer: DomSanitizer, private router: Router, private SpinnerService: NgxSpinnerService, private authService: AuthService, private fb: FormBuilder) {
    // this.updatePaginatedPublishers();
    this.tagFormFunc();
    this.deploymentFormFunc();
    this.genresFormFunc();
    this.artistFormFunc();
    this.UserFormFunc();
    this.roleFormFunc();
    this.publsiherFormFunc();
    this.musicFormFunc();
    this.tagsLIstingFormFunc();
    this.fileterFormFunc();
    this.changePaaswordFormFunc();
  }
  fileterFormFunc() {
    return this.filterForm = this.fb.group({
      publisher: [null],
      artist: [null],
      album: [null],
    });
  }
  tagsLIstingFormFunc() {
    return this.tagsListingForm = this.fb.group({
      tags: [[], Validators.required]
    });
  }
  changePaaswordFormFunc() {
    return this.passwordForm = this.fb.group({
      email: ['', [Validators.required, Validators.pattern(/^(?!.*\.\.)(?!.*\-\-)[a-zA-Z0-9._%+-]{1,64}@[a-zA-Z](?:[a-zA-Z-]{0,61}[a-zA-Z])?\.[a-zA-Z]{2,}$/)]],
      currentPassword: ['', Validators.required],
      newPassword: [
        '',
        [
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(20),
          this.passwordStrengthValidator
        ]
      ],
      confirmPassword: ['', Validators.required],
    });
  }
  musicFormFunc() {
    return this.musicForm = this.fb.group({
      publisher: [{ value: 'Smartcode', disabled: true }, Validators.required],
      name: [
        '',
        [Validators.required, this.noSpecialCharactersOrEmojis]
      ],
      language: ['', Validators.required],
      shortDescription: ['', Validators.required],
      restrictedCountries: [[]],
      eligibleCountires: [[], Validators.required],
      musicFile: ['', Validators.required],

    });
  }
  publsiherFormFunc() {
    return this.publisherForm = this.fb.group({
      publisherName: [
        '',
        [Validators.required, this.noSpecialCharactersOrEmojis]
      ],
      contactPersonName: ['', Validators.required],
      email: ['', [Validators.required, Validators.pattern(/^(?!.*\.\.)(?!.*\-\-)[a-zA-Z0-9._%+-]{1,64}@[a-zA-Z](?:[a-zA-Z-]{0,61}[a-zA-Z])?\.[a-zA-Z]{2,}$/)]],
      contactNumber: ['', [Validators.required, Validators.pattern(/^\d{9}$/)]]
    });
  }

  UserFormFunc() {
    return this.userForm = this.fb.group({
      username: [
        '',
        [Validators.required, this.noSpecialCharactersOrEmojis]
      ],
      email: ['', [Validators.required, Validators.pattern(/^(?!.*\.\.)(?!.*\-\-)[a-zA-Z0-9._%+-]{1,64}@[a-zA-Z](?:[a-zA-Z-]{0,61}[a-zA-Z])?\.[a-zA-Z]{2,}$/)]],
      contactNumber: ['', [Validators.required, Validators.pattern(/^\d{9}$/)]],
      password: [
        '',
        [
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(20),
          this.passwordStrengthValidator
        ]
      ],
      role: new FormControl([], Validators.required)
    });
  }

  roleFormFunc() {
    return this.roleForm = this.fb.group({
      role: new FormControl([], Validators.required)
    });
  }

  genresFormFunc() {
    return this.genreForm = this.fb.group({
      genreName: [
        '',
        [Validators.required, this.noSpecialCharactersOrEmojis]
      ],
    });
  }

  artistFormFunc() {
    return this.artistForm = this.fb.group({
      artistName: [
        '',
        [Validators.required, this.noSpecialCharactersOrEmojis]
      ],
    });
  }

  tagFormFunc() {
    return this.tagForm = this.fb.group({
      tagName: [
        '',
        [Validators.required, this.noSpecialCharactersOrEmojis]
      ],
      contentType: [
        '',
        Validators.required
      ]
    });
  }

  deploymentFormFunc() {
    return this.deploymentForm = this.fb.group({
      deploymentName: [
        '',
        [Validators.required, this.noSpecialCharactersOrEmojis]
      ],
    });
  }

  noSpecialCharactersOrEmojis(control: AbstractControl): ValidationErrors | null {
    const value = control.value || '';
    const regex = /^[a-zA-Z0-9 ]+$/; // Allows only alphanumeric characters and spaces
    return regex.test(value) ? null : { invalidCharacters: true };
  }

  passwordStrengthValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value || '';
    const hasUpperCase = /[A-Z]/.test(value);
    const hasLowerCase = /[a-z]/.test(value);
    const hasNumeric = /\d/.test(value);
    const hasSpecialCharacter = /[!@#$%^&*(),.?":{}|<>]/.test(value);

    const isValid = hasUpperCase && hasLowerCase && hasNumeric && hasSpecialCharacter;
    return !isValid ? { passwordStrength: true } : null;
  }

  openAddForm(content: any, publisher: any) {
    if (publisher) {
      this.rejectedNametuneId = publisher.id
      this.requestName = publisher.requestName
    }
    this.toBeEditedTagId = null
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
  }

  deleteModel(id: any, text: any) {
    this.toBeDeletedId = id;
    this.toBeDeletedText = text;
  }

  onSubmit(event: Event) {
    event.preventDefault();
  }

  onCancel() {
    this.modalService.dismissAll();
  }

  showRoleDropdown(): boolean {
    return this.roles && this.roles.some((role: any) => role.role === 'Super Admin');
  }

  showUserDropdown(): boolean {
    return this.roles && this.roles.some((role: any) => role.role === 'Super Admin' || role.role === 'Admin');
  }

  CreateMusicPermissions(): boolean {
    return this.roles && this.roles.some((role: any) => role.role === 'Super Admin' || role.role === 'Publisher' || role.role === 'Admin');
  }

  showUserManagementDropdown(): boolean {
    return this.roles.some((role: any) => role.role === 'Super Admin' || role.role === 'Admin');
  }

  ngOnInit(): void {
    this.openMuisc();
    history.pushState(null, '', location.href);
    window.addEventListener('popstate', (event: any) => {
      const previousURL = document.referrer;
      const newGeneratedUrl = previousURL.split('/').pop();

      if (newGeneratedUrl === 'login' || newGeneratedUrl === '') {
        history.pushState(null, '', location.href);
      }
    });

    let user: any = localStorage.getItem('username');
    if (user) {
      this.userName = JSON.parse(user);
    }
    let roles: any = localStorage.getItem('role');
    if (roles) {
      this.roles = JSON.parse(roles);
    }

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'role',
      dropUp: true,
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1000000,
      searchPlaceholderText: 'Search....',
      noDataAvailablePlaceholderText: 'No Data Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false,
    };
    this.countrySettings = {
      singleSelection: false,
      text: 'Select Countries',
      idField: 'id',
      dropUp: true,
      textField: 'countryName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: false, // Disable search filter clearing
      maxHeight: 197,
      itemsShowLimit: 1000000,
      searchPlaceholderText: 'Search....',
      noDataAvailablePlaceholderText: 'No Data Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false,
    };

    this.tagsSettings = {
      singleSelection: false,
      text: 'Select Tags',
      idField: 'id',
      dropUp: true,
      textField: 'tagName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1000000,
      searchPlaceholderText: 'Search....',
      noDataAvailablePlaceholderText: 'No Data Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false,
    };
  }

  getAllLanguage() {
    this.SpinnerService.show();
    this.authService.getAllLanguages().subscribe(
      (response) => {
        this.SpinnerService.hide();
        this.languageArray = response;
      },
      (error) => {
        this.SpinnerService.hide();
        console.error(error);
      }
    );
  }

  selectTab(tab: string) {
    this.SpinnerService.show();

    this.selectAll = false;
    this.searchTerm = '';
    this.pageSize = 10;
    this.selectedTab = tab;

    const isRequested = tab === 'Requested';
    this.namertune = isRequested;
    this.approved = false;
    this.approvalPending = false;

    (isRequested ? this.authService.getAllRequestedNamertune() : this.authService.getAllNamertunes())
      .subscribe({
        next: (res: any[]) => {
          const data = (res || []).map(m => ({
            ...m,
            checked: false,
            image: m.releaseResources?.find((r: any) => r.fileTypeId == 4)?.downloadUrl || null
          }));

          if (!data.length) {
            this.musicArray = this.filteredMusicArray = this.musicListedArray = this.tabMusicArray = [];
            this.SpinnerService.hide();
            return;
          }

          this.filteredMusicArray = [...data];

          if (!isRequested) {
            if (tab === 'Pending') {
              this.approvalPending = true;
              tab = 'Approval Pending';
            }

            this.selectedTab = tab;

            this.musicArray = tab === 'All'
              ? [...this.filteredMusicArray]
              : this.filteredMusicArray.filter((x: any) => x.status === tab);

            this.approved = tab === 'Approved';
          } else {
            this.musicArray = [...this.filteredMusicArray];
          }

          this.filteredMusicArray = [...this.musicArray];
          this.musicListedArray = [...this.musicArray];
          this.tabMusicArray = [...this.musicArray];

          this.totalEntries = this.musicArray.length;
          this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);

          this.setRecordsPerPage(10, this.musicArray, 'Music', 'filter_apply');
          this.musicArray = this.updateDisplayedRecords(this.musicArray, 'Music', 'filter_apply');

          this.generatePages();

          this.disabledButtonss = this.disabledDeploy = this.disableApproved = true;

          this.SpinnerService.hide();
        },
        error: () => this.SpinnerService.hide()
      });
  }

  @HostListener('click') onClick() {
    const dropdown = this.el.nativeElement.querySelector('.ng-dropdown-panel');
    if (dropdown) {
      const rect = dropdown.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;

      if (spaceBelow < dropdown.offsetHeight && spaceAbove > dropdown.offsetHeight) {
        this.renderer.addClass(dropdown, 'open-upward');
      } else {
        this.renderer.removeClass(dropdown, 'open-upward');
      }
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      const fileType = file.type;

      if (!['image/png', 'image/jpeg', 'image/jpg', 'image/webp'].includes(fileType)) {
        window.alert('Please upload a valid PNG, JPG, JPEG, or WebP file.');
        this.selectedImage = null;
        input.value = '';
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        this.selectedImage = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  onGenreFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      const fileType = file.type;

      if (!['image/png', 'image/jpeg', 'image/jpg', 'image/webp'].includes(fileType)) {
        window.alert('Please upload a valid PNG, JPG, JPEG, or WebP file.');
        this.selectedenereImage = null;
        input.value = '';
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        this.selectedenereImage = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  applySearch(text: string) {
    const trimAndLowerCase = (value: string) => value?.trim().toLowerCase() || '';

    const freeHandSearchHandler = (array: any[], filteredArray: any[]) => {
      const searchTerm = trimAndLowerCase(this.searchTerm);
      const excludeKeys = ['thumbnailUrl', 'image', 'thumbnail', 'songThumbnail', 'streamUrl'];

      if (searchTerm) {
        return filteredArray.filter((item) =>
          Object.entries(item).some(([key, value]: [string, any]) => {
            if (excludeKeys.includes(key)) return false;

            const normalizedValue = Array.isArray(value)
              ? value.join(' ').toLowerCase()
              : String(value).toLowerCase();

            return normalizedValue.includes(searchTerm);
          })
        );
      }
      return [...filteredArray];
    };


    switch (text) {
      case 'Music':
        this.tabMusicArray = [];
        this.musicArray = freeHandSearchHandler(this.musicArray, this.musicListedArray);
        break;
      case 'Deployment':

        this.deploymentsArray = freeHandSearchHandler(this.deploymentsArray, this.deploymentListedArray);
        break;
      case 'Artist':
        this.artistArray = freeHandSearchHandler(this.artistArray, this.artistListedArray);
        break;
      case 'Role':
        this.roleArray = freeHandSearchHandler(this.roleArray, this.roleListedArray);
        break;
      case 'User':
        this.userArray = freeHandSearchHandler(this.userArray, this.userListedArray);
        break;
      case 'Genre':
        this.genreArray = freeHandSearchHandler(this.genreArray, this.genreListedArray);
        break;
      case 'Tag':
        this.tagsArray = freeHandSearchHandler(this.tagsArray, this.tagListedArray);
        break;
      case 'Publisher':
        this.publisherArray = freeHandSearchHandler(this.publisherArray, this.publisherListedArray);
        break;
      default:
        break;
    }
    if (!this.searchTerm && text == 'Music') {
      this.musicArray = [...this.musicListedArray];
    }
    if (!this.searchTerm && text == 'Publisher') {
      this.publisherArray = [...this.publisherListedArray];
    }
    if (!this.searchTerm && text == 'Tag') {
      this.tagsArray = [...this.tagListedArray];
    }
    if (!this.searchTerm && text == 'Genre') {
      this.genreArray = [...this.genreListedArray];
    }
    if (!this.searchTerm && text == 'User') {
      this.userArray = [...this.userListedArray];
    }
    if (!this.searchTerm && text == 'Role') {
      this.roleArray = [...this.roleListedArray];
    }
    if (!this.searchTerm && text == 'Artist') {
      this.artistArray = [...this.artistListedArray];
    }
    if (!this.searchTerm && text == 'Deployment') {
      this.deploymentsArray = [...this.deploymentListedArray];
    }
    // Reset pagination for every case
    this.resetPaginationAndRecords(this.searchTerm ? 'search_apply' : '', text);
    this.pageSize = 10;
  }



  resetPaginationAndRecords(text: string, title: any) {
    switch (title) {
      case 'Music':
        this.filteredMusicArray = [...this.musicArray];
        this.totalEntries = this.musicArray.length;
        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
        this.setRecordsPerPage(10, this.musicArray, title, text);
        this.musicArray = this.updateDisplayedRecords(this.musicArray, title, text);
        this.generatePages();
        break;
      case 'Deployment':
        this.filteredDeployementArray = [...this.deploymentsArray];
        this.totalEntries = this.deploymentsArray.length;
        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
        this.setRecordsPerPage(10, this.deploymentsArray, title, text);
        this.deploymentsArray = this.updateDisplayedRecords(this.deploymentsArray, title, text);
        this.generatePages();
        break;
      case 'Artist':
        this.filteredArtistArray = [...this.artistArray];
        this.totalEntries = this.artistArray.length;
        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
        this.setRecordsPerPage(10, this.artistArray, title, text);
        this.artistArray = this.updateDisplayedRecords(this.artistArray, title, text);
        this.generatePages();
        break;
      case 'Role':
        this.filteredRoleArray = [...this.roleArray];
        this.totalEntries = this.roleArray.length;
        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
        this.setRecordsPerPage(10, this.roleArray, title, text);
        this.roleArray = this.updateDisplayedRecords(this.roleArray, title, text);
        this.generatePages();
        break;
      case 'User':
        this.filteredUserArray = [...this.userArray];
        this.totalEntries = this.userArray.length;
        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
        this.setRecordsPerPage(10, this.userArray, title, text);
        this.userArray = this.updateDisplayedRecords(this.userArray, title, text);
        this.generatePages();
        break;
      case 'Genre':
        this.filteredGeneresArray = [...this.genreArray];
        this.totalEntries = this.genreArray.length;
        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
        this.setRecordsPerPage(10, this.genreArray, title, text);
        this.genreArray = this.updateDisplayedRecords(this.genreArray, title, text);
        this.generatePages();
        break;
      case 'Tag':
        this.filteredTgasArray = [...this.tagsArray];
        this.totalEntries = this.tagsArray.length;
        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
        this.setRecordsPerPage(10, this.tagsArray, title, text);
        this.tagsArray = this.updateDisplayedRecords(this.tagsArray, title, text);
        this.generatePages();
        break;
      case 'Publisher':
        this.filteredPublisherArray = [...this.publisherArray];
        this.totalEntries = this.publisherArray.length;
        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
        this.setRecordsPerPage(10, this.publisherArray, title, text);
        this.publisherArray = this.updateDisplayedRecords(this.publisherArray, title, text);
        this.generatePages();
        break;
      default:
        break;
    }
  }


  getAllPublishers() {
    this.SpinnerService.show();
    this.authService.getAllpublishers().subscribe(
      (response) => {
        this.SpinnerService.hide();
        this.publisherArray = response;
        this.activePublishers = this.publisherArray.filter(publisher => publisher.publisherStatus === 'Active');
        this.filteredPublisherArray = [...this.publisherArray];
        this.publisherListedArray = [...this.filteredPublisherArray];
        this.totalEntries = this.publisherArray.length;
        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
        this.setRecordsPerPage(10, this.publisherArray, 'Publisher', '');
        this.publisherArray = this.updateDisplayedRecords(this.publisherArray, 'Publisher', '');
        this.generatePages();
      },
      (error) => {
        this.SpinnerService.hide();
        console.error(error);
      }
    );
  }

  getAllMusic() {
    this.SpinnerService.show();
    this.authService.getAllNamertunes().subscribe(
      (response) => {
        this.SpinnerService.hide();
        if (response && response.length) {
          this.musicArray = response;
          this.filteredMusicArray = [...this.musicArray];
          this.musicListedArray = [...this.filteredMusicArray];
          this.totalEntries = this.musicArray.length;
          this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
          this.setRecordsPerPage(10, this.musicArray, 'Music', '');
          this.musicArray = this.updateDisplayedRecords(this.musicArray, 'Music', '');
          this.generatePages();
          if (this.selectedTab) {
            this.selectTab(this.selectedTab);
          }
          if (this.musicArray.length && !this.selectedTab) {
            this.SpinnerService.hide();
          }
        }
      },
      (error) => {
        this.SpinnerService.hide();
        console.error(error);
      }
    );
  }

  getAllUsers() {
    this.SpinnerService.show();
    this.authService.getAllUsers().subscribe(
      (response) => {
        this.SpinnerService.hide();
        this.userArray = response;
        this.filteredUserArray = [...this.userArray];
        this.userListedArray = [...this.filteredUserArray];
        this.totalEntries = this.userArray.length;
        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
        this.setRecordsPerPage(10, this.userArray, 'User', '');
        this.userArray = this.updateDisplayedRecords(this.userArray, 'User', '');
        this.generatePages();
      },
      (error) => {
        this.SpinnerService.show();
        console.error(error);
      }
    );
  }
  getAllRoles() {
    this.SpinnerService.show();
    this.authService.getAllRoles().subscribe(
      (response) => {
        this.SpinnerService.hide();
        this.roleArray = response;
        this.filteredRoleArray = [...this.roleArray];
        this.roleListedArray = [...this.filteredRoleArray];
        this.totalEntries = this.roleArray.length;
        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
        this.setRecordsPerPage(10, this.roleArray, 'Role', '');
        this.roleArray = this.updateDisplayedRecords(this.roleArray, 'Role', '');
        this.generatePages();
      },
      (error) => {
        this.SpinnerService.show();
        console.error(error);
      }
    );

  }

  getAllArtists() {
    this.SpinnerService.show();
    this.authService.getAllArtists().subscribe(
      (response) => {
        this.SpinnerService.hide();
        this.artistArray = response;
        this.filteredArtistArray = [...this.artistArray];
        this.artistListedArray = [...this.filteredArtistArray];
        this.totalEntries = this.artistArray.length;
        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
        this.setRecordsPerPage(10, this.artistArray, 'Artist', '');
        this.artistArray = this.updateDisplayedRecords(this.artistArray, 'Artist', '');
        this.generatePages();
      },
      (error) => {
        this.SpinnerService.hide();
        console.error(error);
      }
    );
  }
  getAllGeneres() {
    this.SpinnerService.show();
    this.authService.getAllGeneres().subscribe(
      (response) => {
        this.SpinnerService.hide();
        this.genreArray = response;
        this.filteredGeneresArray = [...this.genreArray];
        this.genreListedArray = [...this.filteredGeneresArray];
        this.totalEntries = this.genreArray.length;
        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
        this.setRecordsPerPage(10, this.genreArray, 'Genre', '');
        this.genreArray = this.updateDisplayedRecords(this.genreArray, 'Genre', '');
        this.generatePages();
      },
      (error) => {
        this.SpinnerService.hide();
        console.error(error);
      }
    );
  }
  getAllDeployments() {
    this.SpinnerService.show();
    this.authService.getAllDeployments().subscribe(
      (response) => {
        this.SpinnerService.hide();
        this.deploymentsArray = response;
        this.filteredDeployementArray = [...this.deploymentsArray];
        this.deploymentListedArray = [...this.filteredDeployementArray];
        this.totalEntries = this.deploymentsArray.length;
        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
        this.setRecordsPerPage(10, this.deploymentsArray, 'Deployment', '');
        this.deploymentsArray = this.updateDisplayedRecords(this.deploymentsArray, 'Deployment', '');
        this.generatePages();
      },
      (error) => {
        this.SpinnerService.hide();
        console.error(error);
      }
    );
  }
  getAllTags() {
    this.SpinnerService.show();
    this.authService.getAllTags().subscribe(
      (response) => {
        this.SpinnerService.hide();
        this.tagsArray = response;
        this.filteredTgasArray = [...this.tagsArray];
        this.tagListedArray = [...this.filteredTgasArray];
        this.totalEntries = this.tagsArray.length;
        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
        this.setRecordsPerPage(10, this.tagsArray, 'Tag', '');
        this.tagsArray = this.updateDisplayedRecords(this.tagsArray, 'Tag', '');
        this.generatePages();
      },
      (error) => {
        this.SpinnerService.hide();
        console.error(error);
      }
    );
  }

  getAllCountry() {
    this.SpinnerService.show();
    this.authService.getAllCountry().subscribe(
      (response) => {
        this.SpinnerService.hide();
        this.countryArray = response;
        console.log(this.countryArray.slice(0, 10));
      },
      (error) => {
        this.SpinnerService.hide();
        console.error(error);
      }
    );
  }

  generatePagination() {
    const pages: (number | string)[] = [];
    if (this.totalPages <= 10) {
      for (let i = 1; i <= this.totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1, 2, 3);
      if (this.currentPage > 4) {
        pages.push('...');
      }

      const start = Math.max(4, this.currentPage - 1);
      const end = Math.min(this.totalPages - 3, this.currentPage + 1);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (this.currentPage < this.totalPages - 3) {
        pages.push('...');
      }

      pages.push(this.totalPages - 2, this.totalPages - 1, this.totalPages);
    }
    this.pages = pages;
  }

  openprofilePopup() {
    this.openConfirmChnagePopup = !this.openConfirmChnagePopup;
  }

  openPublisher() {
    this.showFilteredOptions = false;
    this.openMusicAddForm = false;
    this.pages = [];
    this.totalEntries = 0;
    this.getAllPublishers();
    this.showContentConfiguration = false;
    this.publisher = true;
    this.deployments = false;
    this.containers = false;
    this.tags = false;
    this.music = false;
    this.conentApproval = false;
    this.Artist = false;
    this.Generes = false;
    this.role = false;
    this.user = false;
  }
  opeContainers() {
    this.showFilteredOptions = false;
    this.openMusicAddForm = false;
    this.showContentConfiguration = false;
    this.containers = true;
    this.deployments = false;
    this.music = false;
    this.conentApproval = false;
    this.tags = false;
    this.publisher = false;
    this.Artist = false;
    this.Generes = false;
    this.role = false;
    this.user = false;
  }
  opeTags() {
    this.showFilteredOptions = false;
    this.openMusicAddForm = false;
    this.pages = [];
    this.totalEntries = 0;
    this.getAllTags();
    this.showContentConfiguration = false;
    this.tags = true;
    this.containers = false;
    this.deployments = false;
    this.publisher = false;
    this.music = false;
    this.conentApproval = false;
    this.Artist = false;
    this.Generes = false;
    this.role = false;
    this.user = false;
  }
  opeUsers() {
    this.showFilteredOptions = false;
    this.openMusicAddForm = false;
    this.pages = [];
    this.totalEntries = 0;
    this.getAllUsers();
    this.authService.getAllRoles().subscribe(
      (response) => {
        this.SpinnerService.hide();
        this.roleArray = response;
      },
      (error) => {
        this.SpinnerService.show();
        console.error(error);
      }
    );
    this.showContentConfiguration = false;
    this.tags = false
    this.containers = false;
    this.deployments = false;
    this.publisher = false;
    this.music = false;
    this.user = true;
    this.role = false;
    this.conentApproval = false;
    this.Artist = false;
    this.Generes = false;
  }
  opeRoles() {
    this.showFilteredOptions = false;
    this.openMusicAddForm = false;
    this.pages = [];
    this.totalEntries = 0;
    this.getAllRoles();
    this.showContentConfiguration = false;
    this.tags = false;
    this.role = true;
    this.user = false;
    this.containers = false;
    this.deployments = false;
    this.publisher = false;
    this.music = false;
    this.conentApproval = false;
    this.Artist = false;
    this.Generes = false;
  }

  openMusicList() {
    this.authService.updateData(true);
    this.router.navigate(['/dashboard'])
  }

  openMuisc() {
    this.resetState();

    forkJoin({
      languages: this.authService.getAllLanguages(),
      countries: this.authService.getAllCountry(),
      tags: this.authService.getAllTags(),
      publishers: this.authService.getAllpublishers(),
      artists: this.authService.getAllArtists(),
      genres: this.authService.getAllGeneres()
    }).subscribe(
      ({ languages, countries, tags, publishers, artists, genres }) => {
        this.languageArray = languages;
        this.countryArray = countries;
        this.tagsArray = tags;
        this.publisherArray = publishers;
        this.artistArray = artists;
        this.genreArray = genres;
      },
      error => console.error(error)
    );

    this.getAllMusic();
  }

  resetState() {
    this.showFilteredOptions = false;
    this.openMusicAddForm = false;  //changes by naved
    this.publisher = false;        //changes by naved
    this.tags = false;             //changes by naved
    this.deployments = false;      //changes by naved
    this.Artist = false;           //changes by naved
    this.Generes = false;          //changes by naved
    this.user = false;             //changes by naved
    this.role = false;             //changes by naved
    this.pages = [];
    this.totalEntries = 0;

    const flags: (keyof HomeComponent)[] = [
      'showContentConfiguration', 'music', 'conentApproval', 'openMusicAddForm',
      'deployments', 'publisher', 'tags', 'containers',
      'Artist', 'Generes', 'role', 'user'
    ];

    // flags.forEach(flag => (this[flag] as boolean) = false);  //changes  by naved
    this.music = true; // Ensure "music" is set to true
  }

  openconentApproval() {
    this.showFilteredOptions = false;
    this.openMusicAddForm = false;
    this.tags = false;
    this.containers = false;
    this.showContentConfiguration = false;
    this.music = false;
    this.conentApproval = true;
    this.openMusicAddForm = false;
    this.deployments = false;
    this.publisher = false;
    this.Artist = false;
    this.Generes = false;
    this.role = false;
    this.user = false;
  }
  openDeployments() {
    this.showFilteredOptions = false;
    this.openMusicAddForm = false;
    this.pages = [];
    this.totalEntries = 0;
    this.getAllDeployments();
    this.Artist = false;
    this.music = false;
    this.containers = false
    this.Generes = false;
    this.showContentConfiguration = false;
    this.deployments = true;
    this.publisher = false;
    this.tags = false;
    this.role = false;
    this.user = false;
  }
  openArtist() {
    this.showFilteredOptions = false;
    this.openMusicAddForm = false;
    this.pages = [];
    this.totalEntries = 0;
    this.getAllArtists();
    this.Artist = true;
    this.Generes = false;
    this.music = false;
    this.containers = false
    this.showContentConfiguration = false;
    this.deployments = false;
    this.publisher = false;
    this.tags = false;
    this.role = false;
    this.user = false;
  }
  openGeneres() {
    this.showFilteredOptions = false;
    this.openMusicAddForm = false;
    this.pages = [];
    this.totalEntries = 0;
    this.getAllGeneres();
    this.Artist = false;
    this.music = false;
    this.containers = false
    this.Generes = true;
    this.showContentConfiguration = false;
    this.deployments = false;
    this.publisher = false;
    this.tags = false;
    this.role = false;
    this.user = false;
  }
  isAllSelected(): boolean {
    const selectedTags = this.musicForm.get('tags')?.value || [];
    return selectedTags.length === this.tagsArray.length;
  }

  // Toggle Select All and Unselect All
  toggleSelectAll(event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    if (checkbox.checked) {
      // Select all tags
      const allTagIds = this.tagsArray.map(tag => tag.id);
      this.musicForm.get('tags')?.setValue(allTagIds);
    } else {
      // Unselect all tags
      this.musicForm.get('tags')?.setValue([]);
    }
  }

  onAddTags() {
    if (this.tagForm.valid) {
      const formData = this.tagForm.value;
      let objJCommmon = {
        id: 0,
        tagName: formData.tagName,
        contentType: formData.contentType
      };
      this.SpinnerService.show();
      if (this.toBeEditedTagId) {
        objJCommmon.id = this.toBeEditedTagId;
        this.authService.updateTag(objJCommmon).subscribe({
          next: (response) => {
            if (response && response.statusCode === 200) {
              this.modalService.dismissAll();
              this.tosterService.success('Tag Updated Successfully');
              this.getAllTags();
              this.tagForm.reset();
              this.SpinnerService.hide();
            } else {
              this.tosterService.error(response.statusCode);
              this.SpinnerService.hide();
              console.error("Unexpected response status:", response);
            }
          },
          error: (err) => {
            if (err && err.statusCode == 200) {
              this.tosterService.error(err.error.message);
              this.modalService.dismissAll();
              this.getAllTags();
              this.tagForm.reset();
              this.SpinnerService.hide();
            } else {
              this.tosterService.error(err.error.message);
              this.SpinnerService.hide();
              console.error("Unexpected response status:", err.error.message);
            }
          }
        });
      } else {
        this.authService.addTag(objJCommmon).subscribe({
          next: (response) => {
            if (response && response.statusCode === 200) {
              this.modalService.dismissAll();
              this.tosterService.success('Tag Created Successfully');
              this.getAllTags();
              this.tagForm.reset();
              this.SpinnerService.hide();
            } else {
              this.tosterService.error('getting error with responce code : ' + ' ' + response.statusCode);
              console.error("Unexpected response status:", response);
              this.SpinnerService.hide();
            }
          },
          error: (err) => {

            this.tosterService.error(err.error.message);
            if (err && err.statusCode == 200) {
              this.modalService.dismissAll();
              this.getAllTags();
              this.tagForm.reset();
              this.SpinnerService.hide();
            }
            console.error("Error adding tag:", err);
            this.SpinnerService.hide();
          }
        });
      }
    } else {
      this.tagForm.markAllAsTouched();
    }
  }

  deleteFunc() {
    if (this.toBeDeletedText === 'Tag') {
      let toBeDeletedObj: any = {
        id: this.toBeDeletedId.id,
        tagName: this.toBeDeletedId.tagName,
        contentType: this.toBeDeletedId.contentType,
      };
      this.SpinnerService.show();
      this.authService.deleteTag(toBeDeletedObj).subscribe({
        next: (response) => {
          this.SpinnerService.hide();
          this.modalService.dismissAll();
          this.getAllTags();
          this.tosterService.success('Tag deleted successfully');
        },
        error: (error) => {
          if (error.status == 200) {
            this.SpinnerService.hide();
            this.modalService.dismissAll();
            this.getAllTags();
            this.tosterService.success('Tag deleted successfully');
          }
          else {
            this.SpinnerService.hide();
            this.modalService.dismissAll();
            this.tosterService.error(error.error.message);
            console.error('Error deleting tag:', error);
          }
        },
      });
    }
    if (this.toBeDeletedText === 'Deployments') {
      let toBeDeletedObj: any = {
        id: this.toBeDeletedId.id,
        serviceName: this.toBeDeletedId.serviceName,
      };
      this.SpinnerService.show();
      this.authService.deleteDeployments(toBeDeletedObj).subscribe({
        next: (response) => {
          this.SpinnerService.hide();
          this.modalService.dismissAll();
          this.getAllDeployments();
          this.tosterService.success('Deployment deleted successfully');
        },
        error: (error) => {
          if (error.status == 200) {
            this.SpinnerService.hide();
            this.modalService.dismissAll();
            this.getAllDeployments();
            this.tosterService.success('Deployment deleted successfully');
          }
          else {
            this.SpinnerService.hide();
            this.modalService.dismissAll();
            this.tosterService.error(error.error.message);
            console.error('Error deleting tag:', error);
          }
        },
      });
    }
    if (this.toBeDeletedText === 'Artist') {
      let toBeDeletedObj: any = {
        id: this.toBeDeletedId.id,
        artistName: this.toBeDeletedId.artistName,
      };
      this.SpinnerService.show();
      this.authService.deleteArtist(toBeDeletedObj).subscribe({
        next: (response) => {
          this.SpinnerService.hide();
          this.modalService.dismissAll();
          this.getAllArtists();
          this.tosterService.success('Artist deleted successfully');
        },
        error: (error) => {
          if (error.status == 200) {
            this.SpinnerService.hide();
            this.modalService.dismissAll();
            this.getAllArtists();
            this.tosterService.success('Artist deleted successfully');
          }
          else {
            this.SpinnerService.hide();
            this.modalService.dismissAll();
            this.tosterService.error(error.error.message);
            console.error('Error deleting tag:', error);
          }
        },
      });
    }
    if (this.toBeDeletedText === 'Genres') {
      let toBeDeletedObj: any = {
        id: this.toBeDeletedId.id,
        categoryName: this.toBeDeletedId.categoryName,
      };
      this.SpinnerService.show();
      this.authService.deleteGenres(toBeDeletedObj).subscribe({
        next: (response) => {
          this.SpinnerService.hide();
          this.modalService.dismissAll();
          this.getAllGeneres();
          this.tosterService.success('Genre deleted successfully');
        },
        error: (error) => {
          if (error.status == 200) {
            this.SpinnerService.hide();
            this.modalService.dismissAll();
            this.getAllGeneres();
            this.tosterService.success('Genre deleted successfully');
          }
          else {
            this.SpinnerService.hide();
            this.modalService.dismissAll();
            this.tosterService.error(error.error.message);
            console.error('Error deleting tag:', error);
          }
        },
      });
    }
    if (this.toBeDeletedText === 'User') {
      let toBeDeletedObj: any = {
        id: this.toBeDeletedId.id,
        email: this.toBeDeletedId.email,
        username: this.toBeDeletedId.username,
        contact: this.toBeDeletedId.contact,
        password: this.toBeDeletedId.password,
        roles: this.toBeDeletedId.roles
      }
      this.SpinnerService.show();
      this.authService.deleteUser(toBeDeletedObj).subscribe({
        next: (response) => {
          this.SpinnerService.hide();
          this.modalService.dismissAll();
          this.getAllUsers();
          this.tosterService.success('User deleted successfully');
        },
        error: (error) => {
          if (error.status == 200) {
            this.SpinnerService.hide();
            this.modalService.dismissAll();
            this.getAllUsers();
            this.tosterService.success('User deleted successfully');
          }
          else {
            this.SpinnerService.hide();
            this.modalService.dismissAll();
            this.tosterService.error(error.error.message);
            console.error('Error deleting tag:', error);
          }
        },
      });
    }
    if (this.toBeDeletedText === 'Publisher') {
      let toBeDeletedObj: any = {
        id: this.toBeDeletedId.id,
        email: this.toBeDeletedId.email,
        publisherName: this.toBeDeletedId.publisherName,
        contactPersonName: this.toBeDeletedId.contactPersonName,
        contact: this.toBeDeletedId.contact,
        publisherStatus: this.toBeDeletedId.publisherStatus
      }
      this.SpinnerService.show();
      this.authService.deletePublisher(toBeDeletedObj).subscribe({
        next: (response) => {
          this.SpinnerService.hide();
          this.modalService.dismissAll();
          this.getAllPublishers();
          this.tosterService.success('Publisher deleted successfully');
        },
        error: (error) => {
          if (error.status == 200) {
            this.SpinnerService.hide();
            this.modalService.dismissAll();
            this.getAllPublishers();
            this.tosterService.success('Publisher deleted successfully');
          }
          else {
            this.SpinnerService.hide();
            this.modalService.dismissAll();
            this.tosterService.error(error.error.message);
            console.error('Error deleting tag:', error);
          }
        },
      });
    }
    if (this.toBeDeletedText === 'NameTune') {  //changes by naved change text Muisc to NameTune
      this.SpinnerService.show();
      this.authService.deleteMusic(this.toBeDeletedId.id).subscribe({
        next: (response) => {
          this.SpinnerService.hide();
          this.modalService.dismissAll();
          this.getAllMusic();
          this.tosterService.success('NameTune deleted successfully');
        },
        error: (error) => {
          if (error.status == 200) {
            this.SpinnerService.hide();
            this.modalService.dismissAll();
            this.getAllMusic();
            this.tosterService.success('NameTune deleted successfully');
          }
          else {
            this.SpinnerService.hide();
            this.modalService.dismissAll();
            this.tosterService.error(error.error.message);
            console.error('Error deleting tag:', error);
          }
        },
      });
    }
    this.searchTerm = '';
  }

  EditTag(Obj: any, text: any) {
    this.SpinnerService.show();
    if (text == 'Tag') {
      this.SpinnerService.show();
      this.toBeEditedTagId = Obj.id;
      this.tagForm.patchValue({
        tagName: Obj.tagName,
        contentType: Obj.contentType,
      });
      this.SpinnerService.hide();
    }
    if (text == 'Deployments') {
      this.SpinnerService.show();
      this.toBeEditedTagId = Obj.id;
      this.deploymentForm.patchValue({
        deploymentName: Obj.serviceName,
      });
      this.SpinnerService.hide();
    }
    if (text == 'Artist') {
      this.SpinnerService.show();
      this.toBeEditedTagId = Obj.id;
      if (Obj.artistImageUrl) {
        this.selectedImage = Obj.artistImageUrl.startsWith('https://')
          ? Obj.artistImageUrl
          : `https://${Obj.artistImageUrl}`;
      }
      this.artistForm.patchValue({
        artistName: Obj.artistName,
      });
      this.SpinnerService.hide();
    }
    if (text == 'Genres') {
      this.SpinnerService.show();
      this.toBeEditedTagId = Obj.id;
      if (Obj.categoryImageUrl) {
        this.selectedenereImage = Obj.categoryImageUrl.startsWith('https://')
          ? Obj.categoryImageUrl
          : `https://${Obj.categoryImageUrl}`;
      }
      this.genreForm.patchValue({
        genreName: Obj.categoryName,
      });
      this.SpinnerService.hide();
    }
    if (text == 'User') {
      this.SpinnerService.show();
      this.toBeEditedTagId = Obj.id;
      let filteredRoleArray = this.roleArray.filter((item: any) =>
        Obj.roles.includes(item.role)
      );
      this.userForm.patchValue({
        username: Obj.username,
        email: Obj.email,
        contactNumber: Obj.contact,
        password: Obj.password,
        role: filteredRoleArray
      });
      this.SpinnerService.hide();
    }
    if (text == 'Role') {
      this.SpinnerService.show();
      this.toBeEditedTagId = Obj.id;
      this.roleForm.patchValue({
        role: [Obj]
      });
      this.SpinnerService.hide();
    }
    if (text == 'Publisher') {
      this.SpinnerService.show();
      this.toBeEditedTagId = Obj.id;
      this.publisherStatus = Obj.publisherStatus;
      this.publisherForm.patchValue({
        email: Obj.email,
        publisherName: Obj.publisherName,
        contactPersonName: Obj.contactPersonName,
        contactNumber: Obj.contact
        // publisherStatus: Obj.publisherStatus
      });
      this.SpinnerService.hide();
    }
    if (text == 'Muisc') {
      this.SpinnerService.show();
      this.openMusicForm();
      this.authService.getMusicById(Obj.id).subscribe(
        (response) => {
          this.SpinnerService.hide();
          this.toBeEditedTagId = response[0].id;
          if (response[0].eligibleCountries.length) {
            response[0].eligibleCountries = this.countryArray.filter((country: any) =>
              response[0].eligibleCountries.includes(country.countryName)
            );
            this.selectedCountries = 'Eligible';

            // Clear validators for restrictedCountries
            this.musicForm.controls['restrictedCountries'].clearValidators();
            this.musicForm.controls['restrictedCountries'].updateValueAndValidity();
          } else if (response[0].restrictedCountries.length) {
            response[0].restrictedCountries = this.countryArray.filter((country: any) =>
              response[0].restrictedCountries.includes(country.countryName)
            );
            this.selectedCountries = 'Restricted';

            // Clear validators for eligibleCountries
            this.musicForm.controls['eligibleCountires'].clearValidators();
            this.musicForm.controls['eligibleCountires'].updateValueAndValidity();
          }
          if (response[0].tags.length) {
            response[0].tags = this.tagsArray.filter((tag: any) =>
              response[0].tags.includes(tag.tagName)
            );
          }
          this.activePublishers.some(pub => pub.publisherName === response[0].publisher)
            ? ''
            : this.errorMessageForPublisher = 'Selected publisher not found !';

          this.musicForm.patchValue({
            publisher: this.activePublishers.some(pub => pub.publisherName === response[0]?.publisher) ? response[0]?.publisher : [],
            name: response[0]?.title || '',
            language: response[0]?.language[0] ? response[0]?.language[0] : [],
            shortDescription: response[0]?.shortDescription || '',
            eligibleCountires: response[0]?.eligibleCountries || [],
            restrictedCountries: response[0]?.restrictedCountries || [],
          });
          response[0].releaseResources.forEach((ele: any) => {
            if (ele.fileTypeId == 5) {
              console.log('file type id is 5');
              this.musicFileUrl = ele.downloadUrl
            }
          });
          this.musicForm.get('language').setValidators(this.toBeEditedTagId ? Validators.required : []);
          this.musicForm.get('language').updateValueAndValidity();
          if (!this.toBeEditedTagId) {
            this.musicForm.get('musicFile')?.setValidators([Validators.required]);
          } else {
            this.musicForm.get('musicFile')?.clearValidators();
          }
          this.musicForm.get('musicFile')?.updateValueAndValidity();
          response[0].releaseResources.forEach((ele: any) => {
            if (ele.fileTypeId == 5) {
              this.musicFileUrl = ele.downloadUrl;
            }
          });
          this.SpinnerService.hide();
        },
        (error) => {
          this.SpinnerService.hide();
          console.error(error);
        }
      );
      this.SpinnerService.hide();
    }
    this.searchTerm = ''
  }

  onSubmitDeployemnts(): void {
    if (this.deploymentForm.valid) {
      const formData = this.deploymentForm.value;
      let objJCommmon = {
        id: 0,
        serviceName: formData.deploymentName,
      };
      this.SpinnerService.show();
      if (this.toBeEditedTagId) {
        objJCommmon.id = this.toBeEditedTagId;
        this.authService.updateDeployment(objJCommmon).subscribe({
          next: (response) => {
            if (response && response.statusCode === 200) {
              this.modalService.dismissAll();
              this.getAllDeployments();
              this.tosterService.success('Deployment updated successfully');
              this.deploymentForm.reset();
              this.SpinnerService.hide();
            } else {
              this.SpinnerService.hide();
              console.error("Unexpected response status:", response);
            }
          },
          error: (err) => {
            if (err && err.statusCode == 200) {
              this.modalService.dismissAll();
              this.getAllDeployments();
              this.tosterService.success('Deployment updated successfully');
              this.deploymentForm.reset();
              this.SpinnerService.hide();
            }
            console.error("Error adding deployment:", err);
            this.SpinnerService.hide();
          }
        });
      } else {

        this.authService.addDeployment(objJCommmon).subscribe({
          next: (response) => {
            if (response && response.statusCode === 200) {
              this.modalService.dismissAll();
              this.getAllDeployments();
              this.tosterService.success('Deployment added successfully');
              this.deploymentForm.reset();
              this.SpinnerService.hide();
            } else {
              console.error("Unexpected response status:", response);
              this.SpinnerService.hide();
            }
          },
          error: (err) => {
            if (err && err.statusCode == 200) {
              this.modalService.dismissAll();
              this.getAllDeployments();
              this.tosterService.success('Deployment added successfully');
              this.deploymentForm.reset();
              this.SpinnerService.hide();
            } else {
              this.modalService.dismissAll();
              // this.getAllDeployments();
              this.tosterService.error(err.error.message);
              this.deploymentForm.reset();
              this.SpinnerService.hide();
            }
            console.error("Error adding tag:", err);
            this.SpinnerService.hide();
          }
        });
      }
    } else {
      this.deploymentForm.markAllAsTouched();
    }
  }

  onAddArtist(): void {
    if (this.artistForm.valid) {
      const formData: any = new FormData();
      formData.append('id', this.toBeEditedTagId ? this.toBeEditedTagId : '0');
      formData.append('artistName', this.artistForm.get('artistName')?.value);
      const input = document.getElementById('artistImage') as HTMLInputElement;
      if (input && input.files && input.files[0]) {
        formData.append('artistImage', input.files[0]);
      }
      else {
        if (this.toBeEditedTagId) {
        } else {
          alert('Please Select Image File also');
          return;
        }
      }
      this.SpinnerService.show();
      if (this.toBeEditedTagId) {
        this.authService.updateArtist(formData).subscribe({
          next: (response) => {
            if (response && response.statusCode === 200) {
              this.modalService.dismissAll();
              this.getAllArtists();
              this.tosterService.success('Artist updated successfully');
              this.artistForm.reset();
              this.SpinnerService.hide();
            } else {
              this.SpinnerService.hide();
              console.error("Unexpected response status:", response);
            }
          },
          error: (err) => {
            if (err && err.statusCode == 200) {
              this.modalService.dismissAll();
              this.getAllArtists();
              this.tosterService.success('Artist updated successfully');
              this.artistForm.reset();
              this.SpinnerService.hide();
            }
            this.tosterService.error(err.error.message);
            console.error("Error adding deployment:", err);
            this.SpinnerService.hide();
          }
        });
      } else {
        this.authService.addArtist(formData).subscribe({
          next: (response) => {
            if (response && response.statusCode === 200) {
              this.modalService.dismissAll();
              this.getAllArtists();
              this.tosterService.success('Artist added successfully');
              this.artistForm.reset();
              this.SpinnerService.hide();
            } else {
              console.error("Unexpected response status:", response);
              this.SpinnerService.hide();
            }
          },
          error: (err) => {
            if (err && err.statusCode == 200) {
              this.modalService.dismissAll();
              this.getAllArtists();
              this.tosterService.success('Artist added successfully');
              this.artistForm.reset();
              this.SpinnerService.hide();
            }
            this.tosterService.error(err.error.message);
            console.error("Error adding tag:", err);
            this.SpinnerService.hide();
          }
        });
      }
    } else {
      this.artistForm.markAllAsTouched();
    }
  }

  onAddGenre(): void {
    if (this.genreForm.valid) {
      const formData: any = new FormData();
      formData.append('id', this.toBeEditedTagId ? this.toBeEditedTagId : '0');
      formData.append('categoryName', this.genreForm.get('genreName')?.value);
      const input = document.getElementById('genreImage') as HTMLInputElement;
      if (input && input.files && input.files[0]) {
        formData.append('categoryImage', input.files[0]);
      }
      else {
        if (this.toBeEditedTagId) {
          // formData.append('artistImage', null);
        } else {
          alert('Please Select Image File also');
          return;
        }
      }
      this.SpinnerService.show();
      if (this.toBeEditedTagId) {
        this.authService.updateGenres(formData).subscribe({
          next: (response) => {
            if (response && response.statusCode === 200) {
              this.modalService.dismissAll();
              this.getAllGeneres();
              this.tosterService.success('Genre updated successfully');
              this.genreForm.reset();
              this.SpinnerService.hide();
            } else {
              this.SpinnerService.hide();
              console.error("Unexpected response status:", response);
            }
          },
          error: (err) => {
            if (err && err.statusCode == 200) {
              this.modalService.dismissAll();
              this.getAllGeneres();
              this.tosterService.success('Genre updated successfully');
              this.genreForm.reset();
              this.SpinnerService.hide();
            }
            this.tosterService.error(err.error.message);
            console.error("Error adding deployment:", err);
            this.SpinnerService.hide();
          }
        });
      } else {
        this.authService.addGenre(formData).subscribe({
          next: (response) => {
            if (response && response.statusCode === 200) {
              this.modalService.dismissAll();
              this.getAllGeneres();
              this.tosterService.success('Genre added successfully');
              this.genreForm.reset();
              this.SpinnerService.hide();
            } else {
              console.error("Unexpected response status:", response);
              this.SpinnerService.hide();
            }
          },
          error: (err) => {
            if (err && err.statusCode == 200) {
              this.modalService.dismissAll();
              this.getAllGeneres();
              this.tosterService.success('Genre added successfully');
              this.genreForm.reset();
              this.SpinnerService.hide();
            }
            this.tosterService.error(err.error.message);
            console.error("Error adding tag:", err);
            this.SpinnerService.hide();
          }
        });
      }
    } else {
      this.genreForm.markAllAsTouched();
    }
  }
  allowOnlyNumbers(event: KeyboardEvent): void {
    const charCode = event.charCode || event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  onAddUser() {
    if (this.userForm.valid) {
      const formData = this.userForm.value;
      let rolesArray = formData.role.map((obj: any) => obj.role);
      let objJCommmon = {
        id: 0,
        email: formData.email.toLowerCase(),
        username: formData.username,
        contact: formData.contactNumber,
        password: formData.password,
        roles: rolesArray
      }
      this.SpinnerService.show();
      if (this.toBeEditedTagId) {
        objJCommmon.id = this.toBeEditedTagId;
        this.authService.updateUser(objJCommmon).subscribe({
          next: (response) => {
            if (response && response.statusCode === 200) {
              this.modalService.dismissAll();
              this.getAllUsers();
              this.tosterService.success('User updated successfully');
              this.userForm.reset();
              this.SpinnerService.hide();
            } else {
              this.SpinnerService.hide();
              console.error("Unexpected response status:", response);
            }
          },
          error: (err) => {
            if (err && err.statusCode == 200) {
              this.modalService.dismissAll();
              this.getAllUsers();
              this.tosterService.success('User updated successfully');
              this.userForm.reset();
              this.SpinnerService.hide();
            }
            this.tosterService.error(err.error.message);
            console.error("Error adding deployment:", err);
            this.SpinnerService.hide();
          }
        });
      } else {
        this.authService.addUser(objJCommmon).subscribe({
          next: (response) => {
            if (response && response.statusCode === 200) {
              this.modalService.dismissAll();
              this.getAllUsers();
              this.tosterService.success('User added successfully');
              this.userForm.reset();
              this.SpinnerService.hide();
            } else {
              console.error("Unexpected response status:", response);
              this.SpinnerService.hide();
            }
          },
          error: (err) => {
            if (err && err.statusCode == 200) {
              this.modalService.dismissAll();
              this.getAllUsers();
              this.tosterService.success('User added successfully');
              this.userForm.reset();
              this.SpinnerService.hide();
            }
            this.tosterService.error(err.error.message);
            console.error("Error adding tag:", err);
            this.SpinnerService.hide();
          }
        });
      }
    } else {
      this.userForm.markAllAsTouched();
    }
  }

  onAddRole() {
    if (this.roleForm.valid) {
      const formData = this.roleForm.value;
      let rolesArray = formData.role.map((obj: any) => obj.role);
      let objJCommmon = {
        id: 0,
        role: rolesArray.join(',')
      }
      this.SpinnerService.show();
      if (this.toBeEditedTagId) {
        objJCommmon.id = this.toBeEditedTagId;
        this.authService.updateRole(objJCommmon).subscribe({
          next: (response) => {
            if (response && response.statusCode === 200) {
              this.modalService.dismissAll();
              this.getAllRoles();
              this.tosterService.success('Role updated successfully');
              this.roleForm.reset();
              this.SpinnerService.hide();
            } else {
              this.SpinnerService.hide();
              console.error("Unexpected response status:", response);
            }
          },
          error: (err) => {
            if (err && err.statusCode == 200) {
              this.modalService.dismissAll();
              this.getAllRoles();
              this.tosterService.success('Role updated successfully');
              this.roleForm.reset();
              this.SpinnerService.hide();
            }
            this.tosterService.error(err.error.message);
            console.error("Error adding deployment:", err);
            this.SpinnerService.hide();
          }
        });
      } else {

      }
    } else {
      this.roleForm.markAllAsTouched();
    }
  }

  onAddPublisher() {
    if (this.publisherForm.valid) {
      const formData = this.publisherForm.value;
      let objJCommmon = {
        id: 0,
        email: formData.email,
        publisherName: formData.publisherName,
        contactPersonName: formData.contactPersonName,
        contact: formData.contactNumber,
        publisherStatus: this.publisherStatus
      }
      this.SpinnerService.show();
      if (this.toBeEditedTagId) {
        objJCommmon.id = this.toBeEditedTagId;
        this.authService.updatePublsiher(objJCommmon).subscribe({
          next: (response) => {
            if (response && response.statusCode === 200) {
              this.modalService.dismissAll();
              this.getAllPublishers();
              this.tosterService.success('Publisher updated successfully');
              this.publisherForm.reset();
              this.SpinnerService.hide();
            } else {
              this.SpinnerService.hide();
              console.error("Unexpected response status:", response);
            }
          },
          error: (err) => {
            if (err && err.statusCode == 200) {
              this.modalService.dismissAll();
              this.getAllPublishers();
              this.tosterService.success('Publisher updated successfully');
              this.publisherForm.reset();
              this.SpinnerService.hide();
            }
            this.tosterService.error(err.error.message);
            console.error("Error adding deployment:", err);
            this.SpinnerService.hide();
          }
        });
      } else {
        this.authService.addPublisher(objJCommmon).subscribe({
          next: (response) => {
            if (response && response.statusCode === 200) {
              this.modalService.dismissAll();
              this.getAllPublishers();
              this.tosterService.success('Publisher added successfully');
              this.publisherForm.reset();
              this.SpinnerService.hide();
            } else {
              console.error("Unexpected response status:", response);
              this.SpinnerService.hide();
            }
          },
          error: (err) => {
            if (err && err.statusCode == 200) {
              this.modalService.dismissAll();
              this.getAllPublishers();
              this.tosterService.success('Publisher added successfully');
              this.publisherForm.reset();
              this.SpinnerService.hide();
            }
            this.tosterService.error(err.error.message);
            console.error("Error adding tag:", err);
            this.SpinnerService.hide();
          }
        });
      }
    } else {
      this.publisherForm.markAllAsTouched();
    }
  }

  onAddMusic(): void {
    const formData = this.musicForm.value;
    const uploadData = new FormData();
    uploadData.append('publisher', this.publisherName);
    uploadData.append('title', formData.name);
    uploadData.append('language', formData.language.languageName ? formData.language.languageName : formData.language ? formData.language : 'English');
    uploadData.append('shortDescription', formData.shortDescription);
    uploadData.append('isNametune', '1')
    uploadData.append(
      'eligibleCountries',
      this.selectedCountries == 'Eligible'
        ? formData.eligibleCountires.map((country: any) => country.countryName ? country.countryName : country).join(', ')
        : null
    );
    uploadData.append(
      'restrictedCountries',
      this.selectedCountries == 'Restricted'
        ? formData.restrictedCountries.map((country: any) => country.countryName ? country.countryName : country).join(', ')
        : null
    );

    if (this.selectedMuiscFile) {
      uploadData.append('nametuneFile', this.selectedMuiscFile);
    }

    this.SpinnerService.show();

    const apiCall = this.toBeEditedTagId
      ? this.authService.updateMusic(this.toBeEditedTagId, uploadData)
      : this.authService.addMusic(uploadData);

    apiCall.subscribe({
      next: (response) => {
        if (response && response.statusCode === 200) {
          this.modalService.dismissAll();
          this.getAllMusic();
          this.tosterService.success(this.toBeEditedTagId ? 'NameTune updated successfully' : 'NameTune added successfully');
          this.musicForm.reset();
          this.preViewImage = null;
          this.selectedCrbtFile = null;
          this.selectedIvrFile = null;
          this.selectedMuiscFile = null;
          this.openMusicAddForm = false;
          this.music = true;
          this.SpinnerService.hide();
        } else {
          console.error('Unexpected response status:', response);
          this.SpinnerService.hide();
        }
      },
      error: (err) => {
        if (err && err.statusCode === 200) {
          this.modalService.dismissAll();
          this.getAllMusic();
          this.tosterService.success(this.toBeEditedTagId ? 'Record updated successfully' : 'Record added successfully');
          this.musicForm.reset();
          this.preViewImage = null;
          this.selectedCrbtFile = null;
          this.selectedIvrFile = null;
          this.selectedMuiscFile = null;
          this.openMusicAddForm = false;
          this.music = true;
          this.SpinnerService.hide();
        } else {
          this.tosterService.error(err.error.message);
          console.error('Error:', err);
          this.SpinnerService.hide();
        }
      },
    });
  }

  sortData(column: string, text: string) {
    const arrayMap: { [key: string]: any[] } = {
      Artists: this.artistListedArray,
      Genres: this.genreListedArray,
      Tags: this.tagListedArray,
      User: this.userListedArray,
      Role: this.roleListedArray,
      Deployments: this.deploymentListedArray,
      Publisher: this.publisherListedArray,
      Music: this.musicListedArray,
    };

    const array = arrayMap[text] || [];

    this.sortDirection = this.sortColumn === column
      ? this.sortDirection === 'asc' ? 'desc' : 'asc'
      : 'asc';

    this.sortColumn = column;

    array.sort((a: any, b: any) => {
      const valA = a[column]?.toString().toLowerCase() || '';
      const valB = b[column]?.toString().toLowerCase() || '';
      return this.sortDirection === 'asc'
        ? valA.localeCompare(valB)
        : valB.localeCompare(valA);
    });
    // **Apply sorting & pagination for all categories**
    switch (text) {
      case 'Music':
        this.musicListedArray = [...array];
        this.tabMusicArray = [...array];
        this.filteredMusicArray = [...this.musicListedArray];
        this.totalEntries = this.musicListedArray.length;
        this.setRecordsPerPage(10, this.musicListedArray, 'Music', '');
        this.musicArray = this.updateDisplayedRecords(this.musicListedArray, 'Music', '');
        break;

      case 'Artists':
        this.artistListedArray = [...array];
        this.filteredArtistArray = [...array];
        this.totalEntries = this.artistListedArray.length;
        this.setRecordsPerPage(10, this.artistListedArray, 'Artist', '');
        this.artistArray = this.updateDisplayedRecords(this.artistListedArray, 'Artist', '');
        break;

      case 'Genres':
        this.genreListedArray = [...array];
        this.filteredGeneresArray = [...array];
        this.totalEntries = this.genreListedArray.length;
        this.setRecordsPerPage(10, this.genreListedArray, 'Genre', '');
        this.genreArray = this.updateDisplayedRecords(this.genreListedArray, 'Genre', '');
        break;

      case 'Tags':
        this.tagsListingForm = [...array];
        this.filteredTgasArray = [...array];
        this.totalEntries = this.tagsListingForm.length;
        this.setRecordsPerPage(10, this.tagsListingForm, 'Tag', '');
        this.tagsArray = this.updateDisplayedRecords(this.tagsListingForm, 'Tag', '');
        break;

      case 'User':
        this.userListedArray = [...array];
        this.filteredUserArray = [...array];
        this.totalEntries = this.userListedArray.length;
        this.setRecordsPerPage(10, this.userListedArray, 'User', '');
        this.userArray = this.updateDisplayedRecords(this.userListedArray, 'User', '');
        break;

      case 'Role':
        this.roleListedArray = [...array];
        this.filteredRoleArray = [...array];
        this.totalEntries = this.roleListedArray.length;
        this.setRecordsPerPage(10, this.roleListedArray, 'Role', '');
        this.roleArray = this.updateDisplayedRecords(this.roleListedArray, 'Role', '');
        break;

      case 'Deployments':
        this.deploymentListedArray = [...array];
        this.filteredDeployementArray = [...array];
        this.totalEntries = this.deploymentListedArray.length;
        this.setRecordsPerPage(10, this.deploymentListedArray, 'Deployment', '');
        this.deploymentsArray = this.updateDisplayedRecords(this.deploymentListedArray, 'Deployment', '');
        break;

      case 'Publisher':
        this.publisherListedArray = [...array];
        this.filteredPublisherArray = [...array];
        this.totalEntries = this.publisherListedArray.length;
        this.setRecordsPerPage(10, this.publisherListedArray, 'Publisher', '');
        this.publisherArray = this.updateDisplayedRecords(this.publisherListedArray, 'Publisher', '');
        break;
    }

    this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
    this.generatePages();
  }

  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  onStatusChange(event: any, publisher: any) {
    publisher.publisherStatus = event.target.checked ? 'Active' : 'Inactive';
    let objJCommmon = {
      id: publisher.id,
      email: publisher.email,
      publisherName: publisher.publisherName,
      contactPersonName: publisher.contactPersonName,
      contact: publisher.contact,
      publisherStatus: publisher.publisherStatus
    }
    this.SpinnerService.show();
    this.authService.updatePublsiher(objJCommmon).subscribe({
      next: (response) => {
        if (response && response.statusCode === 200) {
          ;
          this.getAllPublishers();
          this.tosterService.success('Status change successfully');
          this.SpinnerService.hide();
        } else {
          this.SpinnerService.hide();
          console.error("Unexpected response status:", response);
        }
      },
      error: (err) => {
        if (err && err.statusCode == 200) {
          this.getAllPublishers();
          this.tosterService.success('Status change successfully');
          this.SpinnerService.hide();
        }
        console.error("Error adding deployment:", err);
        this.SpinnerService.hide();
      }
    });
  }

  updatePageSize(event: Event, text: string): void {
    const target = event.target as HTMLSelectElement;
    const newPageSize = +target.value;
    this.recordsPerPage = newPageSize;
    this.pageSize = newPageSize;

    const arrayMap: { [key: string]: any[] } = {
      Music: this.filteredMusicArray,
      Deployment: this.filteredDeployementArray,
      Artist: this.filteredArtistArray,
      Role: this.filteredRoleArray,
      Genre: this.filteredGeneresArray,
      User: this.filteredUserArray,
      Tag: this.filteredTgasArray,
      Publisher: this.filteredPublisherArray
    };

    const array = arrayMap[text] || [];
    this.totalPages = Math.ceil(array.length / this.recordsPerPage);
    this.currentPage = 1;
    this.updateDisplayedRecords(array, text, '');
    this.generatePages();
  }

  updateDisplayedRecords(array: any[], text: string, str: string): any[] {
    const startIndex = (this.currentPage - 1) * this.recordsPerPage;
    const endIndex = startIndex + this.recordsPerPage;
    switch (text) {
      case 'Music':
        this.musicArray = [];
        array = (str == 'search_apply') ? array.slice(startIndex, endIndex)
          : (str == 'filter_apply') ? array.slice(startIndex, endIndex)
            : this.tabMusicArray.length ? this.tabMusicArray.slice(startIndex, endIndex)
              : this.filteredMusicArray.slice(startIndex, endIndex);
        this.musicArray = array;
        break;
      case 'Deployment':
        array = (str == 'search_apply') ? array.slice(startIndex, endIndex) : this.filteredDeployementArray.slice(startIndex, endIndex);
        this.deploymentsArray = array;
        break;
      case 'Artist':
        array = (str == 'search_apply') ? array.slice(startIndex, endIndex) : this.filteredArtistArray.slice(startIndex, endIndex);
        this.artistArray = array;
        break;
      case 'Role':
        array = (str == 'search_apply') ? array.slice(startIndex, endIndex) : this.filteredRoleArray.slice(startIndex, endIndex);
        this.roleArray = array;
        break;
      case 'User':
        array = (str == 'search_apply') ? array.slice(startIndex, endIndex) : this.filteredUserArray.slice(startIndex, endIndex);
        this.userArray = array;
        break;
      case 'Genre':
        array = (str == 'search_apply') ? array.slice(startIndex, endIndex) : this.filteredGeneresArray.slice(startIndex, endIndex);
        this.genreArray = array;
        break;
      case 'Tag':
        array = (str == 'search_apply') ? array.slice(startIndex, endIndex) : this.filteredTgasArray.slice(startIndex, endIndex);
        this.tagsArray = array;
        break;
      case 'Publisher':
        array = (str == 'search_apply') ? array.slice(startIndex, endIndex) : this.filteredPublisherArray.slice(startIndex, endIndex);
        this.publisherArray = array;
        break;
      default:
        array = [];
        break;
    }

    return array;
  }

  get startEntry(): number {
    return this.totalEntries === 0 ? 0 : (this.currentPage - 1) * this.recordsPerPage + 1;
  }

  get endEntry(): number {
    const end = this.currentPage * this.recordsPerPage;
    return Math.min(end, this.totalEntries);
  }

  onRecordsPerPageChange(event: any, array: any) {
    this.pageSize = +event.target.value;
    this.getPaginatedData(array);
  }

  getPaginatedData(array: any) {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.userArray = array.slice(startIndex, endIndex);
  }

  goToPage(page: any, array: any[], text: any) {
    if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
      this.currentPage = page;
      this.updateDisplayedRecords(array, text, '');
      this.generatePages();
    }
  }

  previousPage(array: any[], text: any) {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updateDisplayedRecords(array, text, '');
      this.generatePages();
    }
  }

  nextPage(array: any[], text: any) {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updateDisplayedRecords(array, text, '');
      this.generatePages();
    }
  }

  setRecordsPerPage(recordsPerPage: number, array: any[], text: any, value: any) {
    this.recordsPerPage = recordsPerPage;
    this.totalEntries = array.length;
    this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
    this.currentPage = 1;
    this.updateDisplayedRecords(array, text, value);
    this.generatePages();
  }

  generatePages() {
    const pagesArray: (number | string)[] = [];
    const maxPagesToShow = 5;
    const halfRange = Math.floor(maxPagesToShow / 2);
    if (this.totalPages <= maxPagesToShow) {
      for (let i = 1; i <= this.totalPages; i++) {
        pagesArray.push(i);
      }
    } else {
      if (this.currentPage <= halfRange + 1) {
        for (let i = 1; i < maxPagesToShow; i++) {
          pagesArray.push(i);
        }
        pagesArray.push('...');
        pagesArray.push(this.totalPages);
      } else if (this.currentPage > this.totalPages - halfRange) {
        pagesArray.push(1);
        pagesArray.push('...');
        for (let i = this.totalPages - (maxPagesToShow - 2); i <= this.totalPages; i++) {
          pagesArray.push(i);
        }
      } else {
        pagesArray.push(1);
        pagesArray.push('...');
        for (let i = this.currentPage - halfRange; i <= this.currentPage + halfRange; i++) {
          pagesArray.push(i);
        }
        pagesArray.push('...');
        pagesArray.push(this.totalPages);
      }
    }
    this.pages = pagesArray;
  }

  selectCountry(country: string): void {
    this.selectedCountries = country;
    if (country === 'Restricted') {
      this.musicForm.controls['restrictedCountries'].setValidators([Validators.required]);
      this.musicForm.controls['eligibleCountires'].clearValidators();
      this.musicForm.controls['eligibleCountires'].setValue(null);
    } else if (country === 'Eligible') {
      this.musicForm.controls['eligibleCountires'].setValidators([Validators.required]);
      this.musicForm.controls['restrictedCountries'].clearValidators();
      this.musicForm.controls['restrictedCountries'].setValue(null);
    } else {
      this.musicForm.controls['restrictedCountries'].clearValidators();
      this.musicForm.controls['restrictedCountries'].clearValidators();
    }
    this.musicForm.controls['restrictedCountries'].updateValueAndValidity();
    this.musicForm.controls['eligibleCountires'].updateValueAndValidity();
  }

  onMusicFileSelected(event: any): void {
    const fileInput = event.target as HTMLInputElement;
    const file = fileInput.files?.[0] ?? null;
    this.selectedMuiscFile = file;
    if (file) {
      const fileExtension = this.getFileExtension(file.name);
      if (fileExtension === 'wav') {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.musicFileUrl = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        alert('Please select a valid wav file.');
        fileInput.value = '';
        this.musicFileUrl = null;
      }
    }
  }

  onAudioFileSelected(event: any, fileType: string): void {
    const fileInput = event.target as HTMLInputElement;
    const file = fileInput.files?.[0];
    if (file) {
      const fileExtension = this.getFileExtension(file.name);
      if (fileExtension === 'wav') {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          if (fileType === 'crbt') {
            this.selectedCrbtFile = file;
            this.crbtFileUrl = e.target.result;
          } else if (fileType === 'ivr') {
            this.selectedIvrFile = file;
            this.ivrFileUrl = e.target.result;
          }
        };
        reader.readAsDataURL(file);
      } else {
        alert('Please select a valid WAV file.');
        fileInput.value = '';
        if (fileType === 'crbt') {
          this.crbtFileUrl = null;
        } else if (fileType === 'ivr') {
          this.ivrFileUrl = null;
        }
      }
    }
  }

  previewImageFile(event: any): void {
    const fileInput = event.target as HTMLInputElement;
    const file = fileInput.files?.[0] ?? null;
    this.preViewImage = file;

    if (file) {
      const fileExtension = this.getFileExtension(file.name).toLowerCase();

      if (['png', 'jpg', 'jpeg', 'webp'].includes(fileExtension)) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.previewImageUrl = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        alert('Please select a valid PNG, JPG, JPEG, or WebP image.');
        fileInput.value = '';
        this.previewImageUrl = null;
      }
    }
  }

  private getFileExtension(fileName: string): string {
    return fileName.split('.').pop()?.toLowerCase() || '';
  }
  disabledButtons = false;
  onCheckboxChange(event: any): void {
    this.selectAll = event.target.checked;
    this.selectAll ? (this.disabledButtons = true) : (this.disabledButtons = false);
    this.filteredMusicArray.forEach((publisher: any) => {
      publisher.checked = this.selectAll;
    });
  }
  onResetFilters() {
    this.SpinnerService.show();
    this.filterForm.reset({
      publisher: null,
      artist: null,
      album: null
    });
    let filterObj = {
      publisher: this.filterForm.value.publisher ? this.filterForm.value.publisher : null,
      artist: this.filterForm.value.artist ? this.filterForm.value.artist : null,
      album: this.filterForm.value.album ? this.filterForm.value.album : null
    }
    this.authService.getAllFilteredMuiscList(filterObj).subscribe(
      (response) => {
        this.musicArray = response;
        this.tabMusicArray = response;
        this.filteredMusicArray = [...this.musicArray];
        this.musicArray.forEach((music: any) => {
          const resourceWithFileType4 = music.releaseResources?.find((res: any) => res.fileTypeId == 4);
          if (resourceWithFileType4) {
            music.image = resourceWithFileType4.downloadUrl;
          }
        });
        if (!filterObj.publisher && !filterObj.artist && !filterObj.album) {
          this.musicArray = [...this.musicListedArray];
        }
        this.totalEntries = this.musicArray.length;
        this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
        this.setRecordsPerPage(10, this.musicArray, 'Music', '');
        this.musicArray = this.updateDisplayedRecords(this.musicArray, 'Music', '');
        this.SpinnerService.hide();
        this.generatePages();
      },
      (error) => {
        this.SpinnerService.hide();
        console.error(error);
      }
    );
    this.pageSize = 10;
  }
  onFilterMuisc() {
    this.SpinnerService.show();
    let filterObj = {
      publisher: this.filterForm.value.publisher?.publisherName ?? this.filterForm.value?.publisher ?? null,
      artist: this.filterForm.value.artist?.artistName ?? this.filterForm.value?.artist ?? null,
      album: this.filterForm.value?.album ?? null
    };
    this.authService.getAllFilteredMuiscList(filterObj).subscribe(
      (response) => {
        filterObj.album = (filterObj.album == "") ? (filterObj.album = null) : filterObj.album;
        if (!filterObj.publisher && !filterObj.artist && !filterObj.album) {
          this.onResetFilters();
        } else {
          this.musicArray = response;
          this.tabMusicArray = response;
          this.filteredMusicArray = [...this.musicArray];
          this.musicArray.forEach((music: any) => {
            const resourceWithFileType4 = music.releaseResources?.find((res: any) => res.fileTypeId == 4);
            if (resourceWithFileType4) {
              music.image = resourceWithFileType4.downloadUrl;
            }
          });
          this.totalEntries = this.musicArray.length;
          this.totalPages = Math.ceil(this.totalEntries / this.recordsPerPage);
          this.setRecordsPerPage(10, this.musicArray, 'Music', '');
          this.musicArray = this.updateDisplayedRecords(this.musicArray, 'Music', '');
          this.generatePages();
          this.SpinnerService.hide();
        }
      },
      (error) => {
        this.SpinnerService.hide();
        console.error(error);
      }
    );
    this.pageSize = 10;
  }

  async fetchMusicDetails(mD: any) {
    console.log(mD.releaseResources[0].downloadUrl);
    let downloadUrl = 'https://' + mD.releaseResources[0].downloadUrl || ''
    if (downloadUrl) {
      const a = document.createElement("a")
      a.href = downloadUrl
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      return;
    }



    this.SpinnerService.show();
    try {
      const publisher = {
        musicId: mD.id,
        name: mD.title,
        artist: mD.artist,
        tags: mD.tags,
        type: mD.type,
        deployedOn: mD.deployedOn,
        status: mD.status,
      };
      const excelData = [
        ["Music ID", "Name", "Artist", "Tags", "Type", "Deployed On", "Status"],
        Object.values(publisher),
      ];
      const ws = XLSX.utils.aoa_to_sheet(excelData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Music Details");
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

      const zip = new JSZip();
      zip.file("MusicDetails.xlsx", excelBuffer);
      const fetchBinaryData = async (url: string): Promise<Uint8Array> => {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Failed to fetch resource: ${url}`);
        }
        const arrayBuffer = await response.arrayBuffer();
        return new Uint8Array(arrayBuffer);
      };

      for (const resource of mD.releaseResources) {
        const { downloadUrl, fileTypeId } = resource;
        let fileName = "";
        switch (fileTypeId) {
          case 4:
            fileName = "Image.jpg";
            break;
          case 1:
            fileName = "Music.mp3";
            break;
          case 2:
            fileName = "CRBT.wav";
            break;
          case 3:
            fileName = "IVR.wav";
            break;
          default:
            console.warn(`Unknown file type: ${fileTypeId}, skipping resource.`);
            continue;
        }

        try {
          console.log(`Attempting to fetch and add file: ${fileName} from URL: ${downloadUrl}`);
          const fileData = await fetchBinaryData(environment.httpMethod + downloadUrl);
          zip.file(fileName, fileData);
          console.log(`Successfully added file: ${fileName} to ZIP.`);
        } catch (error) {
          console.error(`Skipping resource due to error: ${downloadUrl}`, error);
        }
      }
      zip.generateAsync({ type: "blob" })
        .then((content) => {
          console.log("ZIP file generated successfully, now you can download or use the content.");
          saveAs(content, "Music_Data.zip");
        })
        .catch((err) => console.error("Error generating ZIP file:", err));
      this.SpinnerService.hide();

    } catch (error) {
      console.error("Error in fetchMusicDetails:", error);
      this.SpinnerService.hide();
    }
  }

  chnageMuiscStatus(text: any, obj: any) {
    this.statusChangeText = text;
    this.statusChangeMuiscDetails = obj;
  }

  onMuiscStatusChange() {
    this.SpinnerService.show();
    const approvalStatusMap: any = { Reject: 5, Approve: 3, Deploy: 2 };
    const approvalMessages: any = {
      Reject: 'Nametune rejected successfully',
      Approve: 'Nametune approved successfully',
      Deploy: 'Nametune deployed successfully',
    };

    const releaseIdArray = [this.statusChangeMuiscDetails.id];
    const releaseId = this.statusChangeMuiscDetails.id;
    const approvalStatusId = approvalStatusMap[this.statusChangeText] || 0;
    const onStatusChangeObj = { releaseId: [releaseId], approvalStatusId };

    const data = {
      releaseId: releaseIdArray,
      isNametune: 1
    };

    if (this.statusChangeText === 'Deploy') {
      // Call deploy API first
      this.authService.onDeployMusicListing(data).subscribe({
        next: () => {
          // If deploy succeeds, call the status change API
          this.authService.onChangeMusicStatus(onStatusChangeObj).subscribe({
            next: () => this.handleSuccess(approvalMessages[this.statusChangeText]),
            error: (error) => this.handleError(error),
          });
        },
        error: (error) => {
          this.handleError(error); // Handle deploy error
        },
      });
    } else {
      // Directly call the status change API for other statuses
      this.authService.onChangeMusicStatus(onStatusChangeObj).subscribe({
        next: () => this.handleSuccess(approvalMessages[this.statusChangeText]),
        error: (error) => this.handleError(error),
      });
    }
  }

  // Helper function to handle success
  handleSuccess(message: string) {
    this.getAllMusic();
    setTimeout(() => {
      this.tosterService.success(message || 'Operation successful');
    }, 1000); // 10000 ms = 10 seconds    
    this.closeModal();
  }

  // Helper function to handle error
  handleError(error: any) {
    this.getAllMusic();
    this.tosterService.error('An error occurred while processing your request');
    this.closeModal();
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  logout() {
    this.SpinnerService.show();
    this.authService.logout().subscribe(
      (response) => {
        if (!response.status) {
          // this.SpinnerService.hide();
          this.modalService.dismissAll();
          this.tosterService.error(response.message);
          console.error(response.message);
        } else {
          localStorage.removeItem('token');
          localStorage.removeItem('username');
          sessionStorage.removeItem('token');
          this.router.navigate(['/login']);
          this.tosterService.success('Logout successfully');
          this.modalService.dismissAll();
        }
        this.SpinnerService.hide();
      },
      (error) => {
        this.SpinnerService.hide();
        this.tosterService.error(error.message);
        this.modalService.dismissAll();
        console.error(error);
      }
    );
  }

  togglePasswordVisibilitys(field: string) {
    switch (field) {
      case 'current':
        this.showCurrentPassword = !this.showCurrentPassword;
        break;
      case 'new':
        this.showNewPassword = !this.showNewPassword;
        break;
      case 'confirm':
        this.showConfirmPassword = !this.showConfirmPassword;
        break;
    }
  }

  get passwordMismatch(): boolean {
    const newPassword = this.passwordForm.get('newPassword')?.value;
    const confirmPassword = this.passwordForm.get('confirmPassword')?.value;
    return newPassword && confirmPassword && newPassword !== confirmPassword;
  }

  chnagePaasword() {
    if (this.passwordForm.valid) {
      if (this.passwordForm.valid && !this.passwordMismatch) {
        let passowrdChange = {
          email: this.passwordForm.value.email,
          oldPassword: this.passwordForm.value.currentPassword,
          newPassword: this.passwordForm.value.newPassword,
          confirmPassword: this.passwordForm.value.confirmPassword
        }
        this.authService.chnagePassword(passowrdChange).subscribe(
          (response) => {
            if (!response.status) {
              this.SpinnerService.hide();
              this.modalService.dismissAll();
              this.tosterService.error(response.message);
              console.error(response.message);
            } else {
              this.SpinnerService.hide();
              this.modalService.dismissAll();
              this.tosterService.success('Passowrd changed successfully');
            }
          },
          (error) => {
            this.SpinnerService.hide();
            this.modalService.dismissAll();
            this.tosterService.error(error.error.message);
            console.error(error);
          }
        );
      }
    } else {
      this.passwordForm.markAllAsTouched();
    }
  }

  selectAllRecords() {
    this.selectAll = true;
    if (this.musicArray.length > 0) {  //changes by naved
      this.musicArray.forEach((publisher: any) => {
        publisher.checked = true;
      });
      console.log(this.musicArray)
      this.disabledButtonss = false;
      this.disabledDeploy = false;
      this.disableApproved = false;
    }
  }

  unselectAllRecords() {
    this.selectAll = false;
    this.filteredMusicArray.forEach((publisher: any) => {
      publisher.checked = false;
    });
    this.disabledButtonss = true;
    this.disabledDeploy = true;
    this.disableApproved = true;
  }

  disabledButtonss = true;
  disabledDeploy = true;
  disableApproved = true;

  onIndividualCheck(row: any) {
    row.checked = !row.checked;
    const checkedCount = this.musicArray.filter(item => item.checked).length;
    if (this.selectedTab == 'Approval Pending') {
      this.disableApproved = checkedCount < 2;
    }
    if (this.selectedTab == 'Approved') {
      this.disabledDeploy = checkedCount < 2;
    }
    if (this.selectedTab == 'Requested') {
      this.disabledButtonss = checkedCount < 2;
    }
  }

  addNamertuneData() { //changes by naved
    const selectedRows = this.musicArray.filter(item => item.checked);
    const namesArray = selectedRows.map(item => item.requestName);
    console.log("Final Names Array:", namesArray);
    this.SpinnerService.show();
    this.authService.addNamertune({ requestName: namesArray }).subscribe({
      next: (response) => {
        console.log("API Response:", response);
        this.SpinnerService.hide()
        this.tosterService.success('Nametune Successfully Added')
        this.selectTab('Requested')
        this.selectedTab = 'Requested'
        this.modalService.dismissAll();
        this.disabledButtonss = true; 
        this.disabledDeploy = true;
        this.disableApproved = true;
      },
      error: (error) => {
        console.error("API Error:", error);
        this.SpinnerService.hide()
      }
    });
  }

  SelectTag(model: any, text: any) {
    const isAnyChecked = this.musicArray.some((publisher: any) => publisher.checked);
    if (isAnyChecked) {
      this.selectedTax = text;
      this.openAddForm(model, "");
    } else {
      alert('Please select atleast one record');
    }
  }


  RemoveTag(model: any, text: any) {
    const isAnyChecked = this.musicArray.some((publisher: any) => publisher.checked);
    if (isAnyChecked) {
      this.selectedTax = text;
      this.openAddForm(model, "");
    } else {
      alert('Please select atleast one record');
    }
  }

  onUpdateTagsStatus(status: boolean) {
    this.SpinnerService.show();
    if (this.tagsListingForm.valid) {
      const checkedIds = this.filteredMusicArray
        .filter((publisher: any) => publisher.checked)
        .map((publisher: any) => publisher.id);
      const tagNamesArray = this.tagsListingForm.value.tags.map((tag: any) => tag.tagName);

      if (checkedIds.length === 0) {
        this.tosterService.warning('Please select at least one item.');
        this.SpinnerService.hide();
        return;
      }

      const tagsObj = {
        releaseId: checkedIds,
        tags: tagNamesArray,
        isDelete: status,
      };

      this.authService.UpadteTagsStatus(tagsObj).toPromise().then(() => {
        this.SpinnerService.hide();
        this.modalService.dismissAll();
        this.getAllMusic();
        this.tosterService.success(`Tags ${status ? 'removed' : 'added'} successfully.`);
        this.selectAll = false;
      }).catch(() => {
        this.tosterService.error(`Failed to ${status ? 'remove' : 'add'} tags. Please try again.`);
      }).finally(() => {
        this.SpinnerService.hide();
      });

    } else {
      this.tagsListingForm.markAllAsTouched();
      this.SpinnerService.hide();
    }
  }


  openMusicForm() {
    this.musicForm.reset();
    this.authService.getAllpublishers().subscribe(
      (response) => {
        this.SpinnerService.hide();
        this.activePublishers = response.filter((publisher: any) => publisher.publisherStatus === 'Active');
      }),
      this.toBeEditedTagId = null;
    this.openMusicAddForm = true;
    this.musicForm.reset();
    this.music = false;
    this.preViewImage = null;
    this.previewImageUrl = null;
    this.crbtFileUrl = null;
    this.selectedCrbtFile = null;
    this.selectedMuiscFile = null;
    this.selectedIvrFile = null;
    this.ivrFileUrl = null;
    this.musicFileUrl = null;
    this.selectedCountries = 'Eligible';
    if (this.languageArray.length > 0) {
      this.musicForm.get('language')?.setValue(this.languageArray[0]);
    }

    const id = environment.id  //changes by naved
    this.authService.getPublisher(id).subscribe({  //changes by naved
      next: (response) => {
        this.publisherName = response[0]?.publisherName
        console.log(this.publisherName)
        if (this.publisherName) {
          this.musicForm.patchValue({
            publisher: this.publisherName
          });
        }
      },
      error: (error) => {
        console.log(error)
      }
    })

  }
  errorMessage: any;
  preventSpace(event: KeyboardEvent): void {
    const inputElement = event.target as HTMLInputElement; // Get the input element
    const currentValue = inputElement.value.trim(); // Get the current value of the input

    if (event.key === ' ') {
      if (currentValue.length === 0) {
        event.preventDefault(); // Prevent space if no characters exist
        this.errorMessage = 'Spaces are not allowed before any character.';
      } else {
        this.errorMessage = ''; // Clear the error message if valid
      }
    } else {
      this.errorMessage = ''; // Clear the error for other keys
    }
  }
  validateInput(): void {
    if (this.searchTerm.trim() !== this.searchTerm) {
      this.errorMessage = 'Input cannot have leading or trailing spaces.';
    } else {
      this.errorMessage = '';
    }
    this.searchTerm = this.searchTerm.trim();
  }

  formatContactNumber(event: any) {
    let value = event.target.value.replace(/\D/g, ''); // Remove non-numeric characters
    if (value.length > 9) {
      value = value.substring(0, 9); // Ensure max 9 digits
    }
    event.target.value = value;
  }

  addNamertune(obj: any) {
    let namertuneData = {
      "requestName": [this.requestName]
    };
    this.SpinnerService.show();
    this.authService.addNamertune(namertuneData).subscribe({
      next: (response) => {
        console.log(response)
        this.SpinnerService.hide();
        this.tosterService.success('Nametune  Successfully Updated');
        this.modalService.dismissAll();
        this.selectTab('Requested')
        this.selectedTab = 'Requested'
      },
      error: (error) => {
        console.log(error)
        this.SpinnerService.hide();
        this.tosterService.error('Something went wrong');
      }
    })
  }

  rejectNamertune(obj: any) {
    this.SpinnerService.show();
    let namertuneData = { nametuneRequestId: this.rejectedNametuneId, status: "REJECTED" }
    this.authService.rejectNamertune(namertuneData).subscribe({
      next: (response) => {
        console.log(response)
        this.SpinnerService.hide();
        this.tosterService.success('Nametune Rejected  Successfully');
        this.modalService.dismissAll();
        this.selectTab('Requested')
        this.selectedTab = 'Requested'
      },
      error: (error) => {
        console.log(error)
        this.SpinnerService.hide();
        this.tosterService.error('Something went wrong');
      }
    })
  }

  validateName(event:any){
    let keyCode = event.keyCode
    if(keyCode <= 105 && keyCode >= 97 ) {
      event.preventDefault();
    }
    if(keyCode <= 57 && keyCode >= 48){
      event.preventDefault();
    }
  }

  openModal(content: any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
  }

  multipleDeploy() {
    const selectedRows = this.musicArray.filter(item => item.checked);
    const namesArray = selectedRows.map(item => item.id);
    const id: Number = 2
    this.SpinnerService.show();

    const onStatusChangeObj = { releaseId: namesArray, approvalStatusId: id };

    const data = {
      releaseId: namesArray,
      isNametune: 1
    };

    console.log("Status Text:", this.statusChangeText);
    console.log("Final Payload:", data);

    this.authService.mulitpleDeploy(data).subscribe({
      next: (response) => {
        console.log("API Response:", response);
        this.SpinnerService.hide()
        this.authService.onChangeMusicStatus(onStatusChangeObj).subscribe({  //changes by naved
          next: (res) =>   {
            this.modalService.dismissAll();
            this.selectedTab = 'Approved'
            this.selectTab('Approved')
          },
          error: (error) => this.handleError(error),
        });
        this.tosterService.success('Nametune Successfully Deployed')
        this.modalService.dismissAll();
      },
      error: (error) => {
        console.error("API Error:", error);
        this.SpinnerService.hide()
      }
    });
  }

  multipleApprove() {
    const selectedRows = this.musicArray.filter(item => item.checked);
    const namesArray = selectedRows.map(item => item.id);

    const id: Number = 3
    const onStatusChangeObj = { releaseId: namesArray, approvalStatusId: id };
    this.SpinnerService.show();
    const data = {
      releaseId: namesArray,
      approvalStatusId: id,
    };
    this.authService.multipleApprove(data).subscribe({
      next: (response) => {
        console.log("API Response:", response);
        this.SpinnerService.hide()
        this.authService.onChangeMusicStatus(onStatusChangeObj).subscribe({
          next: () =>{ //changes by naved
            this.modalService.dismissAll();
            this.selectTab('Pending')
            this.selectedTab = 'Approval Pending'
          },
          error: (error) => this.handleError(error),
        });
        this.tosterService.success('Nametune Successfully Approved')
      },
      error: (error) => {
        console.error("API Error:", error);
        this.SpinnerService.hide()
      }
    });
  }

}